webpackJsonp([7],{

/***/ 1512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(1810);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143fa953_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1981);
function injectStyle (ssrContext) {
  __webpack_require__(1937)
  __webpack_require__(1939)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-143fa953"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143fa953_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1550);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1562);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1560);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1561) });


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(955);
var gOPS = __webpack_require__(1558);
var pIE = __webpack_require__(1555);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(959);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(442)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1564), __esModule: true };

/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(957);
__webpack_require__(1565);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(221);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(965);
var isArrayIter = __webpack_require__(966);
var toLength = __webpack_require__(445);
var createProperty = __webpack_require__(1566);
var getIterFn = __webpack_require__(963);

$export($export.S + $export.F * !__webpack_require__(967)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1557);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 1597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      required: true,
      default: ''
    },
    placeholder: {
      type: String,
      default: null,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    inputClass: {
      type: String,
      required: false
    },
    titleClass: {
      type: String,
      default: '',
      required: false
    },
    maxLength: {
      type: Number,
      required: false,
      default: 100
    },
    valueType: {
      type: String,
      required: false
    },
    errorMode: {
      type: String,
      default: ''
    },
    onlyNumbersWithNegatives: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      this.myValue = newVal;
    }
  },
  data: function data() {
    return {
      myValue: this.value
    };
  },

  computed: {
    classDef: function classDef() {
      return this.errorMode === '' ? 'input pl-2  ' + this.inputClass : 'input pl-2 error ' + this.inputClass;
    },
    titleDef: function titleDef() {
      return this.titleClass === '' ? 'title mt-3' : this.titleClass + ' mt-3';
    }
  },
  methods: {
    onChange: function onChange(evt) {
      this.$emit("onChange", evt.target.value);
    }
  }
});

/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo.a7b8e63.svg";

/***/ }),

/***/ 1621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__ = __webpack_require__(1597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1491b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__ = __webpack_require__(1626);
function injectStyle (ssrContext) {
  __webpack_require__(1622)
  __webpack_require__(1624)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e1491b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1491b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1623);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("15b7d214", content, true, {});

/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "input:disabled{background:#f1f1f1}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/TextField.vue"],"names":[],"mappings":"AACA,eACE,kBAAoB,CACrB","file":"TextField.vue","sourcesContent":["\ninput:disabled {\n  background: #f1f1f1;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("08bb99e4", content, true, {});

/***/ }),

/***/ 1625:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".input[data-v-3e1491b2]{border-radius:5px;color:#000}input[data-v-3e1491b2]::-webkit-input-placeholder{color:#0095b2}input[data-v-3e1491b2]::-moz-placeholder{color:#0095b2}input[data-v-3e1491b2]::-ms-input-placeholder{color:#0095b2}input[data-v-3e1491b2]::placeholder{color:#0095b2}input[data-v-3e1491b2]::-webkit-inner-spin-button,input[data-v-3e1491b2]::-webkit-outer-spin-button{-webkit-appearance:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/TextField.vue"],"names":[],"mappings":"AACA,wBACE,kBAAmB,AACnB,UAAa,CACd,AACD,kDACE,aAAwB,CACzB,AACD,yCACE,aAAwB,CACzB,AACD,8CACE,aAAwB,CACzB,AACD,oCACE,aAAwB,CACzB,AACD,oGAEI,uBAAyB,CAC5B","file":"TextField.vue","sourcesContent":["\n.input[data-v-3e1491b2] {\n  border-radius: 5px;\n  color: black;\n}\ninput[data-v-3e1491b2]::-webkit-input-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-moz-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-ms-input-placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::placeholder {\n  color: rgb(0, 149, 178);\n}\ninput[data-v-3e1491b2]::-webkit-outer-spin-button,\ninput[data-v-3e1491b2]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:_vm.titleDef},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),((_vm.valueType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.myValue)?_vm._i(_vm.myValue,null)>-1:(_vm.myValue)},on:{"change":[function($event){var $$a=_vm.myValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.myValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.myValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.myValue=$$c}},_vm.onChange]}}):((_vm.valueType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":"radio"},domProps:{"checked":_vm._q(_vm.myValue,null)},on:{"change":[function($event){_vm.myValue=null},_vm.onChange]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.myValue),expression:"myValue"}],class:_vm.classDef,attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"maxLength":_vm.maxLength,"oninput":"this.value = this.value.slice(0, this.maxLength)","type":_vm.valueType},domProps:{"value":(_vm.myValue)},on:{"change":_vm.onChange,"input":function($event){if($event.target.composing){ return; }_vm.myValue=$event.target.value}}}),_vm._v(" "),(_vm.errorMode !== '')?_c('p',{staticClass:"error",staticStyle:{"font-size":"13px","border":"none","color":"rgb(218, 97, 97)"}},[_vm._v(_vm._s(_vm.errorMode))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-simple-spinner v1.2.10 (https://github.com/dzwillia/vue-simple-spinner)
 * (c) 2018 David Z. Williams
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueSimpleSpinner"] = factory();
	else
		root["VueSimpleSpinner"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VueSimpleSpinner = undefined;

var _Spinner = __webpack_require__(1);

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof window !== 'undefined' && window.Vue) {
  Vue.component('vue-simple-spinner', _Spinner2.default);
}

exports.VueSimpleSpinner = _Spinner2.default;
exports.default = _Spinner2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(9),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("d89557e4", content, true);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".vue-simple-spinner{transition:all .3s linear}@keyframes vue-simple-spinner-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(6)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var isNumber = function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

exports.default = {
  props: {
    'size': {
      default: 32
    },
    'line-size': {
      type: Number,
      default: 3
    },
    'line-bg-color': {
      type: String,
      default: '#eee'
    },
    'line-fg-color': {
      type: String,
      default: '#2196f3' },
    'speed': {
      type: Number,
      default: 0.8
    },
    'spacing': {
      type: Number,
      default: 4
    },
    'message': {
      type: String,
      default: ''
    },
    'font-size': {
      type: Number,
      default: 13
    },
    'text-fg-color': {
      type: String,
      default: '#555'
    }
  },
  computed: {
    size_px: function size_px() {
      switch (this.size) {
        case 'tiny':
          return 12;
        case 'small':
          return 16;
        case 'medium':
          return 32;
        case 'large':
          return 48;
        case 'big':
          return 64;
        case 'huge':
          return 96;
        case 'massive':
          return 128;
      }

      return isNumber(this.size) ? this.size : 32;
    },
    line_size_px: function line_size_px() {
      switch (this.size) {
        case 'tiny':
          return 1;
        case 'small':
          return 2;
        case 'medium':
          return 3;
        case 'large':
          return 3;
        case 'big':
          return 4;
        case 'huge':
          return 4;
        case 'massive':
          return 5;
      }

      return isNumber(this.lineSize) ? this.lineSize : 4;
    },
    text_margin_top: function text_margin_top() {
      switch (this.size) {
        case 'tiny':
        case 'small':
        case 'medium':
        case 'large':
        case 'big':
        case 'huge':
        case 'massive':
          return Math.min(Math.max(Math.ceil(this.size_px / 8), 3), 12);
      }

      return isNumber(this.spacing) ? this.spacing : 4;
    },
    text_font_size: function text_font_size() {
      switch (this.size) {
        case 'tiny':
        case 'small':
        case 'medium':
        case 'large':
        case 'big':
        case 'huge':
        case 'massive':
          return Math.min(Math.max(Math.ceil(this.size_px * 0.4), 11), 32);
      }

      return isNumber(this.fontSize) ? this.fontSize : 13;
    },
    spinner_style: function spinner_style() {
      return {
        'margin': '0 auto',
        'border-radius': '100%',
        'border': this.line_size_px + 'px solid ' + this.lineBgColor,
        'border-top': this.line_size_px + 'px solid ' + this.lineFgColor,
        'width': this.size_px + 'px',
        'height': this.size_px + 'px',
        'animation': 'vue-simple-spinner-spin ' + this.speed + 's linear infinite'
      };
    },
    text_style: function text_style() {
      return {
        'margin-top': this.text_margin_top + 'px',
        'color': this.textFgColor,
        'font-size': this.text_font_size + 'px',
        'text-align': 'center'
      };
    }
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vue-simple-spinner",
    style: (_vm.spinner_style)
  }), _vm._v(" "), (_vm.message.length > 0) ? _c('div', {
    staticClass: "vue-simple-spinner-text",
    style: (_vm.text_style)
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])
},staticRenderFns: []}

/***/ })
/******/ ])["default"];
});

/***/ }),

/***/ 1696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['icon', 'text'],
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 1697:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjIzIiBoZWlnaHQ9IjIwIiByeD0iMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxsaW5lIHgxPSI5LjUiIHkxPSIxMS41IiB4Mj0iMjAuNSIgeTI9IjExLjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI1LjUiIGN5PSIxMS41IiByPSIxLjUiIGZpbGw9IndoaXRlIi8+CjxsaW5lIHgxPSI5LjUiIHkxPSIxNi41IiB4Mj0iMjAuNSIgeTI9IjE2LjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8Y2lyY2xlIGN4PSI1LjUiIGN5PSIxNi41IiByPSIxLjUiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 1726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconButton_vue__ = __webpack_require__(1696);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fca2984_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconButton_vue__ = __webpack_require__(1734);
function injectStyle (ssrContext) {
  __webpack_require__(1732)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fca2984"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fca2984_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1732:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1733);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("8b687b80", content, true, {});

/***/ }),

/***/ 1733:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".icon-text[data-v-7fca2984]{margin-top:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/IconButton.vue"],"names":[],"mappings":"AACA,4BACE,cAAgB,CACjB","file":"IconButton.vue","sourcesContent":["\n.icon-text[data-v-7fca2984] {\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical icon-button",staticStyle:{"justify-content":"center","align-items":"center"},on:{"click":_vm.onClick}},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"icon-text noselect"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticClass:"selected"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1735:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main_EditProfile_vue__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IconButton__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Main_Menu_NavigationMenu_vue__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Main_UserMenu_vue__ = __webpack_require__(1977);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal_vue__["a" /* default */],
        EditProfile: __WEBPACK_IMPORTED_MODULE_2__components_Main_EditProfile_vue__["a" /* default */],
        IconButton: __WEBPACK_IMPORTED_MODULE_4__components_IconButton__["a" /* default */],
        Spinner: __WEBPACK_IMPORTED_MODULE_5_vue_simple_spinner___default.a,
        NavigationMenu: __WEBPACK_IMPORTED_MODULE_6__components_Main_Menu_NavigationMenu_vue__["a" /* default */],
        UserMenu: __WEBPACK_IMPORTED_MODULE_7__components_Main_UserMenu_vue__["a" /* default */]
    },
    computed: {
        isSystem: function isSystem() {
            return this.$store.getters.systemId != null || this.$route.fullPath.includes('systemState');
        }
    },
    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.$root.$i18n.locale = _this.$store.getters.language;

                            _this.$router.beforeEach(function (to, from, next) {
                                if (_this.$store.getters.isMobile) {
                                    _this.menuVisible = false;
                                }
                                next();
                            });

                            _this.$nextTick(function (_) {
                                _this.menuVisible = !_this.$store.getters.isMobile;
                            });

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    data: function data() {
        return {
            activeModal: 'NONE',
            navigationMenu: [{
                href: { name: 'systems' },
                title: 'Systems',
                icon: 'fa fa-user',
                child: [{
                    href: { name: 'map' },
                    title: 'Map'
                }, {
                    href: { name: 'dashboard' },
                    title: 'Dashboard'
                }]
            }, {
                href: { name: 'alarms' },
                title: 'Alarms'
            }, {
                href: { name: 'visits' },
                title: 'Service'
            }, {
                href: { name: 'users' },
                title: 'Users',
                child: [{
                    href: { name: 'users' },
                    title: 'List'
                }, {
                    href: { name: 'invitations' },
                    title: 'Invitations'
                }]
            }],
            menuVisible: false,
            menuAbsolute: false
        };
    },

    methods: {
        editProfile: function editProfile() {
            this.activeModal = 'EDITPROFILE';
        }
    }
});

/***/ }),

/***/ 1811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TextField__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResetPasswordModal_vue__ = __webpack_require__(1944);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    props: [],
    watch: {},
    methods: {
        getData: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var user, response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_92" /* getUserData */])();

                            case 2:
                                user = _context.sent;

                                this.user = user;
                                _context.next = 6;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_93" /* getUserPhoto */])(user.id);

                            case 6:
                                response = _context.sent;

                                this.photoData = response.data;
                                if (this.photoData != null) {
                                    this.photo = URL.createObjectURL(this.photoData);
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getData() {
                return _ref.apply(this, arguments);
            }

            return getData;
        }(),
        cancel: function cancel() {
            this.$emit('cancel');
        },
        save: function save() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var user, formData, fullName;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_121" /* updateCurrentUserData */])(_this.user);

                            case 2:
                                _context2.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_92" /* getUserData */])();

                            case 4:
                                user = _context2.sent;
                                formData = new FormData();

                                formData.append('Image', _this.photoData);
                                formData.append('ImageType', _this.photoData.type);
                                _context2.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_131" /* updateUserPhoto */])(user.id, formData);

                            case 10:
                                fullName = user.firstName + ' ' + user.surname;

                                _this.$store.dispatch('update_profile', fullName);
                                _this.$store.dispatch('update_avatar', _this.photoData);
                                _this.$emit('save');

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        photoChange: function photoChange(e) {
            this.photo = URL.createObjectURL(e.target.files[0]);
            this.photoData = e.target.files[0];
        },
        openPhotoSelect: function openPhotoSelect() {
            document.getElementById('file-chooser').click();
        },
        closeDialog: function closeDialog() {
            this.$emit('cancel');
        },
        resetPasswordModal: function resetPasswordModal() {
            this.showDialog = 'RESETPWD';
        },
        resetPwdClosed: function resetPwdClosed() {
            this.showDialog = 'NONE';
        }
    },
    computed: {},
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_3__components_Button__["a" /* default */],
        TextField: __WEBPACK_IMPORTED_MODULE_2__components_TextField__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_5__Modal_vue__["a" /* default */],
        ResetPasswordModal: __WEBPACK_IMPORTED_MODULE_6__ResetPasswordModal_vue__["a" /* default */]
    },
    mounted: function mounted() {
        this.getData();
    },
    data: function data() {
        return {
            user: {},
            photo: null,
            photoData: null,
            showDialog: 'NONE'
        };
    }
});

/***/ }),

/***/ 1812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(952);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Modal: __WEBPACK_IMPORTED_MODULE_1__Modal_vue__["a" /* default */], Button: __WEBPACK_IMPORTED_MODULE_0__Button_vue__["a" /* default */] },
    props: {
        email: {
            required: true,
            type: String
        }
    },
    data: function data() {
        return {
            error: ''
        };
    },

    methods: {
        save: function save() {
            var _this = this;

            this.error = '';
            var pwd = document.getElementById('rpm-old').value;
            var nw = document.getElementById('rpm-new').value;
            var rep = document.getElementById('rpm-repeat').value;
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["o" /* changePassword */])({ Email: this.email, OldPassword: pwd, NewPassword: nw, ConfirmNewPassword: rep }).then(function () {
                // console.log('positive')
                _this.$emit('close');
            }).catch(function (error) {
                try {
                    _this.error = error.response.data.map(function (m) {
                        return m.description;
                    }).join('\n');
                } catch (e) {
                    if (_this.error == '') {
                        _this.error = error.response.data;
                    }
                }
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 1813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sidebar_menu__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_sidebar_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_sidebar_menu__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Ikony trzymamy jako require, bo pozycje menu są zwykłymi obiektami JS —
// url-loader zamienia ścieżkę na URL (albo data URI dla małych SVG) w buildzie.
var ICONS = {
    alarms: __webpack_require__(1955),
    animals: __webpack_require__(1956),
    chart: __webpack_require__(1957),
    cloud: __webpack_require__(1958),
    contact: __webpack_require__(1959),
    dashboard: __webpack_require__(1960),
    device: __webpack_require__(1961),
    faq: __webpack_require__(1962),
    mail: __webpack_require__(1963),
    maps: __webpack_require__(1964),
    roughage: __webpack_require__(1965),
    sensors: __webpack_require__(1735),
    service: __webpack_require__(1966),
    settings: __webpack_require__(1967),
    sorting: __webpack_require__(1968),
    statistics: __webpack_require__(1969),
    systems: __webpack_require__(1697),
    ticketsNew: __webpack_require__(1970),
    ticketsNone: __webpack_require__(1971),
    todo: __webpack_require__(1972),
    todoNone: __webpack_require__(1973),
    todoNull: __webpack_require__(1974),
    users: __webpack_require__(1975)
};

var COLLAPSED_STORAGE_KEY = 'menuCollapsed';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SidebarMenu: __WEBPACK_IMPORTED_MODULE_2_vue_sidebar_menu__["SidebarMenu"]
    },
    props: {
        isVisible: {
            type: Boolean,
            default: true,
            required: true
        },
        absolute: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data: function data() {
        return {
            collapsed: localStorage.getItem(COLLAPSED_STORAGE_KEY) === 'true',
            expandedWidth: '250px',
            collapsedWidth: '65px'
        };
    },

    computed: {
        notUser: function notUser() {
            return this.$store.getters.isAdmin || this.$store.getters.isService;
        },

        // Na mobile menu wysuwa się nad treść i zawsze pokazuje pełne pozycje —
        // tryb ikon miałby tam sens tylko razem z toggle, który jest ukryty.
        isCollapsed: function isCollapsed() {
            return this.collapsed && !this.$store.getters.isMobile;
        },
        containerWidth: function containerWidth() {
            if (!this.isVisible) return '0px';
            return this.isCollapsed ? this.collapsedWidth : this.expandedWidth;
        },

        // Szerokości wystawiamy też jako zmienne CSS, bo z nich liczona jest
        // szerokość wysuwki pokazywanej przy hoverze w trybie ikon.
        containerStyle: function containerStyle() {
            return {
                position: this.absolute ? 'absolute' : 'relative',
                width: this.containerWidth,
                '--menu-width': this.expandedWidth,
                '--menu-width-collapsed': this.collapsedWidth
            };
        },
        hasSystem: function hasSystem() {
            return this.$route.params.systemName !== undefined;
        },

        // Pozycje systemowe pokazujemy tylko wtedy, gdy jakiś system jest otwarty.
        // Cała sekcja to jedna gałąź podpięta pod nazwę systemu, żeby było widać,
        // że to kontekst systemu, a nie kolejne pozycje menu głównego; params
        // przekazujemy w całości, bo trasy systemState wymagają :systemName i :systemId.
        //
        // alias trzyma gałąź rozwiniętą także na podstronach, których nie ma w menu
        // (np. szczegóły problemu) — bez tego sidebar uznałby sekcję za nieaktywną
        // i zwinął ją użytkownikowi pod ręką.
        systemMenu: function systemMenu() {
            var params = this.$route.params;
            if (!this.hasSystem) return [];

            return [{
                title: params.systemName,
                class: 'vsm--link_system',
                alias: ['/systemState/:systemName/:systemId', '/systemState/:systemName/:systemId/(.*)', '/devices/:systemName/:systemId'],
                icon: { element: 'img', attributes: { src: ICONS.sensors, alt: '' } },
                child: this.systemMenuChildren(params)
            }];
        },
        mainMenu: function mainMenu() {
            var isAdmin = this.$store.getters.isAdmin;

            return [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.item('Systems', 'systems', ICONS.systems), {
                child: [this.item('Map', 'map'), this.item('Dashboard', 'dashboard'), !this.$store.getters.isUser && this.item('Weights', 'weights')].filter(Boolean)
            }), isAdmin ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.item('Users', 'users', ICONS.users), {
                child: [this.item('Invitations', 'invitations'), this.item('Contacts', 'contacts')]
            }) : this.$store.getters.isService && this.item('Contacts', 'contacts', ICONS.contact), this.notUser && this.item('Alarms', 'alarms', ICONS.alarms), this.notUser && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.item('Service', 'visits', ICONS.service), {
                child: [this.item('Visits', 'visitsList'), this.item('Problems', 'visitsProblems'), this.item('Solutions', 'visitsSolutions')]
            }), isAdmin && this.item('Cloud', 'cloud', ICONS.cloud), this.item('FAQ', 'faq', ICONS.faq), isAdmin && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.item('Software', 'software', ICONS.cloud), {
                child: [this.item('SoftwareDownloads', 'software'), this.item('SoftwareVersions', 'softwareManagement'), this.item('Requirements', 'softwareRequirements')]
            }), isAdmin && this.item('Backups', 'backups', ICONS.cloud), isAdmin && this.item('ScheduledReports', 'scheduledReports', ICONS.mail), isAdmin && this.item('ApiUsage', 'apiUsage', ICONS.chart)].filter(Boolean);
        },
        menu: function menu() {
            return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.systemMenu), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.mainMenu));
        },
        tasksIcon: function tasksIcon() {
            var hasTasks = this.$store.getters.hasTasks;
            if (hasTasks == null) return ICONS.todoNull;
            return hasTasks ? ICONS.todo : ICONS.todoNone;
        },
        ticketsIcon: function ticketsIcon() {
            return this.$store.getters.hasTickets ? ICONS.ticketsNew : ICONS.ticketsNone;
        }
    },
    methods: {
        systemMenuChildren: function systemMenuChildren(params) {
            return [this.item('General', 'settingsGeneral', ICONS.settings, params), this.item('Tasks', 'systemsTasks', this.tasksIcon, params), this.item('Animals', 'systemAnimals', ICONS.animals, params), this.item('Devices', 'settingsDevices', ICONS.device, params), this.notUser && this.item('DeviceAlarms', 'settingsAlarms', ICONS.alarms, params), this.notUser && this.item('General Alarms', 'systemsGeneralAlarms', ICONS.alarms, params), this.item('Roughage', 'settingsRoughage', ICONS.roughage, params), this.item('Sorting', 'settingsSorting', ICONS.sorting, params), this.item('Statistics', 'settingsStatistics', ICONS.statistics, params), this.notUser && this.item('Visits', 'systemVisits', ICONS.service, params), this.notUser && this.item('Problems', 'settingsProblems', ICONS.service, params), this.notUser && this.item('Settings', 'systemSettings', ICONS.settings, params), this.notUser && this.item('Tickets', 'systemTickets', this.ticketsIcon, params), this.notUser && this.item('Notifications', 'systemNotifications', ICONS.mail, params)].filter(Boolean);
        },

        // Tytuł tłumaczymy tutaj, bo komponent sidebara renderuje item.title
        // jako czysty tekst. Klucze zostają te same, co w starym szablonie.
        item: function item(titleKey, routeName, icon, params) {
            return {
                href: params ? { name: routeName, params: params } : { name: routeName },
                title: this.$t(titleKey),
                icon: icon ? { element: 'img', attributes: { src: icon, alt: '' } } : undefined
            };
        },
        onToggleCollapse: function onToggleCollapse(collapsed) {
            this.collapsed = collapsed;
            localStorage.setItem(COLLAPSED_STORAGE_KEY, collapsed);
        }
    }
});

/***/ }),

/***/ 1814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_js__ = __webpack_require__(952);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Ikony (ścieżki z lucide, jak w service-ui) wstawiane przez v-html do <svg>,
// który ustawia viewBox i obrys — stałe, nie dane od użytkownika.
var ICONS = {
    chevronDown: '<path d="m6 9 6 6 6-6"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    user: '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    logOut: '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/>',
    moon: '<path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/>',
    monitor: '<rect width="20" height="14" x="2" y="3" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/>'

    // Flagi jako SVG, bo emoji flag nie renderują się na Windowsie.
};var FLAGS = {
    pl: '<rect width="60" height="40" fill="#fff"/><rect y="20" width="60" height="20" fill="#dc143c"/>',
    uk: '<clipPath id="user-menu-uk-clip"><path d="M30,20 h30 v20 z v20 h-30 z h-30 v-20 z v-20 h30 z"/></clipPath>' + '<rect width="60" height="40" fill="#012169"/>' + '<path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" stroke-width="8"/>' + '<path d="M0,0 L60,40 M60,0 L0,40" clip-path="url(#user-menu-uk-clip)" stroke="#c8102e" stroke-width="5"/>' + '<path d="M30,0 v40 M0,20 h60" stroke="#fff" stroke-width="13"/>' + '<path d="M30,0 v40 M0,20 h60" stroke="#c8102e" stroke-width="8"/>',
    // Proporcje krzyża z flagi 22:16 przeskalowane do 60x40.
    no: '<rect width="60" height="40" fill="#ba0c2f"/>' + '<path d="M16.4,0 h10.9 v40 h-10.9 z M0,15 h60 v10 h-60 z" fill="#fff"/>' + '<path d="M19.1,0 h5.5 v40 h-5.5 z M0,17.5 h60 v5 h-60 z" fill="#00205b"/>'
};

var THEME_OPTIONS = [{ value: 'light', icon: 'sun', labelKey: 'ThemeLight' }, { value: 'dark', icon: 'moon', labelKey: 'ThemeDark' }, { value: 'system', icon: 'monitor', labelKey: 'ThemeSystem' }];

// Nazwy języków zostają w oryginale, jak w dotychczasowym selekcie.
var LANGUAGE_OPTIONS = [{ value: 'English', label: 'English', flag: FLAGS.uk }, { value: 'Polish', label: 'Polski', flag: FLAGS.pl }, { value: 'Norwegian', label: 'Norsk', flag: FLAGS.no }];

// Menu otwiera się po najechaniu; zwłoka przy zamykaniu pozwala przejechać
// kursorem z przycisku na panel bez gubienia hovera.
var CLOSE_DELAY_MS = 180;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UserMenu',
    data: function data() {
        return {
            isOpen: false,
            isLanguageOpen: false,
            focusedLanguage: -1,
            avatarFailed: false,
            icons: ICONS,
            themeOptions: THEME_OPTIONS,
            languageOptions: LANGUAGE_OPTIONS
        };
    },

    computed: {
        user: function user() {
            return this.$store.getters.user || {};
        },
        displayName: function displayName() {
            var name = this.user.fullName;
            return name && name.trim() !== '' ? name : this.$t('Anonymous');
        },
        roleLabel: function roleLabel() {
            var roles = this.user.roles;
            return roles && roles[0] ? this.$t(roles[0]) : this.$t('NoRole');
        },
        initials: function initials() {
            var name = (this.user.fullName || '').trim();
            if (name === '') return '?';
            return name.split(/\s+/).slice(0, 2).map(function (part) {
                return part[0];
            }).join('').toUpperCase();
        },

        // URL liczony raz na zdjęcie, a nie przy każdym renderze — stary
        // getAvatar() tworzył nowy blob URL (i nowe zapytanie) co render.
        avatarUrl: function avatarUrl() {
            var avatar = this.$store.getters.avatar;
            return avatar ? URL.createObjectURL(avatar) : null;
        },
        showPhoto: function showPhoto() {
            return this.avatarUrl != null && !this.avatarFailed;
        },
        theme: function theme() {
            return this.$store.getters.theme;
        },
        language: function language() {
            return this.$store.getters.language;
        },
        currentLanguage: function currentLanguage() {
            var _this = this;

            return LANGUAGE_OPTIONS.find(function (x) {
                return x.value === _this.language;
            }) || LANGUAGE_OPTIONS[0];
        }
    },
    watch: {
        avatarUrl: function avatarUrl(url, previousUrl) {
            if (previousUrl) URL.revokeObjectURL(previousUrl);
            this.avatarFailed = false;
        }
    },
    created: function created() {
        // Poza data(), bo to stan pomocniczy, na który szablon nie reaguje.
        this.closeTimer = null;
        this.lastPointerType = null;
    },
    mounted: function mounted() {
        if (this.$store.getters.avatar == null) this.loadAvatar();
    },
    beforeDestroy: function beforeDestroy() {
        clearTimeout(this.closeTimer);
        if (this.avatarUrl) URL.revokeObjectURL(this.avatarUrl);
    },

    methods: {
        open: function open() {
            clearTimeout(this.closeTimer);
            this.isOpen = true;
        },
        close: function close() {
            clearTimeout(this.closeTimer);
            this.isOpen = false;
            this.closeLanguage();
        },
        toggleLanguage: function toggleLanguage() {
            if (this.isLanguageOpen) {
                this.closeLanguage();
            } else {
                this.isLanguageOpen = true;
                this.focusedLanguage = LANGUAGE_OPTIONS.indexOf(this.currentLanguage);
            }
        },
        closeLanguage: function closeLanguage() {
            this.isLanguageOpen = false;
            this.focusedLanguage = -1;
        },

        // Lista jest własnym elementem w panelu, a nie natywnym <select> — natywna lista
        // otwiera się poza panelem i menu z hoverem zamykałoby się w trakcie wyboru.
        // Klawiatura jak w selekcie: strzałki, Enter/spacja, Escape zamyka tylko listę.
        onLanguageKeydown: function onLanguageKeydown(event) {
            var count = LANGUAGE_OPTIONS.length;
            switch (event.key) {
                case 'ArrowDown':
                case 'ArrowUp':
                    event.preventDefault();
                    if (!this.isLanguageOpen) {
                        this.toggleLanguage();
                        return;
                    }
                    this.focusedLanguage = (this.focusedLanguage + (event.key === 'ArrowDown' ? 1 : count - 1)) % count;
                    break;
                case 'Enter':
                case ' ':
                    if (!this.isLanguageOpen || this.focusedLanguage < 0) return;
                    event.preventDefault();
                    this.setLanguage(LANGUAGE_OPTIONS[this.focusedLanguage].value);
                    break;
                case 'Escape':
                    if (!this.isLanguageOpen) return;
                    event.stopPropagation();
                    this.closeLanguage();
                    this.$refs.languageTrigger.focus();
                    break;
                case 'Tab':
                    this.closeLanguage();
                    break;
            }
        },

        // Hover obsługujemy tylko dla myszy. Na dotyku przeglądarka emuluje
        // najechanie przy tapnięciu i menu otwierałoby się i zamykało naraz.
        onPointerEnter: function onPointerEnter(event) {
            if (event.pointerType === 'mouse') this.open();
        },
        onPointerLeave: function onPointerLeave(event) {
            var _this2 = this;

            if (event.pointerType !== 'mouse') return;
            clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(function () {
                _this2.isOpen = false;
            }, CLOSE_DELAY_MS);
        },

        // Myszą menu jest już otwarte z hovera, więc klik go nie zamyka;
        // dotyk i klawiatura przełączają.
        onTriggerClick: function onTriggerClick() {
            if (this.lastPointerType === 'mouse') {
                this.open();
            } else {
                this.isOpen ? this.close() : this.open();
            }
            this.lastPointerType = null;
        },
        editProfile: function editProfile() {
            this.close();
            this.$emit('edit-profile');
        },
        setTheme: function setTheme(value) {
            this.$store.dispatch('change_theme', value);
        },

        // Kultura Syncfusion i część tłumaczeń ustawia się przy starcie,
        // dlatego po zmianie języka przeładowujemy stronę, jak dotychczas.
        setLanguage: function setLanguage(value) {
            this.closeLanguage();
            if (value === this.language) return;
            this.$store.dispatch('change_language', value);
            location.reload();
        },
        logout: function logout() {
            var _this3 = this;

            this.close();
            this.$store.dispatch('logout').then(function () {
                return _this3.$router.push('/');
            });
        },
        loadAvatar: function loadAvatar() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this4.user.userId) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 2:
                                _context.prev = 2;
                                _context.next = 5;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api_js__["_93" /* getUserPhoto */])(_this4.user.userId);

                            case 5:
                                response = _context.sent;

                                _this4.$store.dispatch('update_avatar', response.data);
                                _context.next = 11;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](2);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4, [[2, 9]]);
            }))();
        }
    }
});

/***/ }),

/***/ 1937:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1938);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("d9620886", content, true, {});

/***/ }),

/***/ 1938:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".profile-modal{left:50vw!important;top:50vh!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Main.vue"],"names":[],"mappings":"AACA,eACI,oBAAsB,AACtB,kBAAqB,CACxB","file":"Main.vue","sourcesContent":["\n.profile-modal {\n    left: 50vw !important;\n    top: 50vh !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1939:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1940);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1853bc76", content, true, {});

/***/ }),

/***/ 1940:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "h1[data-v-143fa953],h2[data-v-143fa953],h3[data-v-143fa953],h4[data-v-143fa953],h5[data-v-143fa953],p[data-v-143fa953],span[data-v-143fa953]{color:#414f51}.box[data-v-143fa953]{height:850px}.nav-bg[data-v-143fa953]{background-image:-webkit-gradient(linear,left top,left bottom,from(#3293a0),to(#356b88));background-image:linear-gradient(#3293a0,#356b88)}main[data-v-143fa953]{background-image:-webkit-gradient(linear,left top,right top,from(#e1eff2),to(#e6f5f8));background-image:linear-gradient(90deg,#e1eff2,#e6f5f8)}img[data-v-143fa953]{vertical-align:middle;display:inline-block}.noselect[data-v-143fa953]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.darkColor[data-v-143fa953]{color:#414f51}#menuCell[data-v-143fa953]{background:#3293a0}.list-group[data-v-143fa953]{overflow-y:auto}.list-group-item[data-v-143fa953]{background:transparent;border:3px solid transparent;padding:4px;width:220px;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-ms-flex-line-pack:start;align-content:flex-start}@media (max-width:670px){.navbar-mobile[data-v-143fa953]{position:absolute;top:0;left:0;height:100%;z-index:100;padding-top:92px}.blur-mobile[data-v-143fa953]{position:absolute;width:100%;height:100%;z-index:99;background-color:rgba(50,147,160,.6)}}#menuCellHelper[data-v-143fa953]:hover,.list-group-item[data-v-143fa953]:hover{border-left:3px solid #fff;border-right:3px solid #fff}.list-group-item[data-v-143fa953]:first-child{border-radius:0}.helper[data-v-143fa953]{display:inline-block;height:100%;vertical-align:middle}.app-header[data-v-143fa953]{position:relative;z-index:20;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 10px;border-bottom:1px solid rgba(0,0,0,.14);color:var(--header-fg)}.app-header[data-v-143fa953],.app-header__start[data-v-143fa953]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px}.app-header__start[data-v-143fa953]{min-width:0;height:100%}.app-header__icon-button[data-v-143fa953]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;width:34px;height:34px;padding:0;border:none;border-radius:8px;background:transparent;color:var(--header-fg);cursor:pointer;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.app-header__icon-button[data-v-143fa953]:hover{background-color:var(--header-hover)}.app-header__icon-button svg[data-v-143fa953]{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.app-header__separator[data-v-143fa953]{-ms-flex-negative:0;flex-shrink:0;width:1px;height:24px;background-color:var(--header-border)}.app-header__logo[data-v-143fa953]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-negative:0;flex-shrink:0}.app-header__logo img[data-v-143fa953]{display:block;height:32px}.app-header__context[data-v-143fa953]{overflow:hidden;color:var(--header-fg);font-size:16px;font-weight:600;white-space:nowrap;text-overflow:ellipsis}.selectedSystemsBackground[data-v-143fa953]{background-color:#007d95}.main-router-view[data-v-143fa953]{background-color:var(--app-bg);width:100%;overflow-x:auto}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Main.vue"],"names":[],"mappings":"AACA,6IACQ,aAAe,CACtB,AACD,sBACQ,YAAc,CACrB,AACD,yBACQ,yFAAkH,AAClH,iDAAwE,CAC/E,AACD,sBACQ,uFAAkH,AAClH,uDAAoF,CAC3F,AACD,qBACQ,sBAAuB,AACvB,oBAAsB,CAC7B,AACD,2BACQ,2BAA4B,AAC5B,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACzB,AACD,4BACQ,aAAuB,CAC9B,AACD,2BACQ,kBAA8B,CACrC,AACD,6BACQ,eAAiB,CACxB,AACD,kCACQ,uBAAwB,AACxB,6BAA8B,AAC9B,YAAa,AACb,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,wBAA0B,CACrC,AACD,yBACA,gCACY,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,YAAa,AACb,gBAAkB,CAC7B,AACD,8BACY,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,oCAAwC,CACnD,CACA,AACD,+EACQ,2BAA6B,AAC7B,2BAA8B,CACrC,AACD,8CACQ,eAAiB,CACxB,AACD,yBACQ,qBAAsB,AACtB,YAAa,AACb,qBAAuB,CAC9B,AAOD,6BACQ,kBAAmB,AACnB,WAAY,AAOZ,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AAEvC,eAAgB,AAChB,wCAA6C,AAC7C,sBAAwB,CAC/B,AACD,iEAdQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAI5B,QAAU,CAejB,AAVD,oCAQQ,YAAa,AACb,WAAa,CACpB,AACD,0CACQ,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACjB,cAAe,AACnB,WAAY,AACZ,YAAa,AACb,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,uBAAwB,AACxB,uBAAwB,AACxB,eAAgB,AAChB,8CAAgD,AAChD,qCAAwC,CAC/C,AACD,gDACQ,oCAAsC,CAC7C,AACD,8CACQ,WAAY,AACZ,YAAa,AACb,UAAW,AACX,oBAAqB,AACrB,eAAgB,AAChB,qBAAsB,AACtB,qBAAuB,CAC9B,AACD,wCACQ,oBAAqB,AACjB,cAAe,AACnB,UAAW,AACX,YAAa,AACb,qCAAuC,CAC9C,AACD,mCACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACjB,aAAe,CAC1B,AACD,uCACQ,cAAe,AACf,WAAa,CACpB,AACD,sCACQ,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,sBAAwB,CAC/B,AACD,4CACM,wBAAuC,CAC5C,AACD,mCACQ,+BAAgC,AAChC,WAAY,AACZ,eAAiB,CACxB","file":"Main.vue","sourcesContent":["\nspan[data-v-143fa953], p[data-v-143fa953], h1[data-v-143fa953], h2[data-v-143fa953], h3[data-v-143fa953], h4[data-v-143fa953], h5[data-v-143fa953] {\n        color: #414F51;\n}\n.box[data-v-143fa953] {\n        height: 850px;\n}\n.nav-bg[data-v-143fa953] {\n        background-image: -webkit-gradient(linear, left top, left bottom, from(rgb(50, 147, 160)), to(rgb(53, 107, 136)));\n        background-image: linear-gradient(rgb(50, 147, 160), rgb(53, 107, 136));\n}\nmain[data-v-143fa953] {\n        background-image: -webkit-gradient(linear, left top, right top, from(rgb(225, 239, 242)), to(rgb(230, 245, 248)));\n        background-image: linear-gradient(to right, rgb(225, 239, 242), rgb(230, 245, 248));\n}\nimg[data-v-143fa953] {\n        vertical-align: middle;\n        display: inline-block;\n}\n.noselect[data-v-143fa953] {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n}\n.darkColor[data-v-143fa953] {\n        color: rgb(65, 79, 81);\n}\n#menuCell[data-v-143fa953] {\n        background: rgb(50, 147, 160);\n}\n.list-group[data-v-143fa953] {\n        overflow-y: auto;\n}\n.list-group-item[data-v-143fa953] {\n        background: transparent;\n        border: 3px solid transparent;\n        padding: 4px;\n        width: 220px;\n        -webkit-box-align: start;\n            -ms-flex-align: start;\n                align-items: flex-start;\n        -ms-flex-line-pack: start;\n            align-content: flex-start;\n}\n@media (max-width: 670px) {\n.navbar-mobile[data-v-143fa953] {\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 100%;\n            z-index: 100;\n            padding-top: 92px;\n}\n.blur-mobile[data-v-143fa953] {\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            z-index: 99;\n            background-color: rgba(50,147,160, 0.6);\n}\n}\n.list-group-item[data-v-143fa953]:hover, #menuCellHelper[data-v-143fa953]:hover {\n        border-left: 3px solid white;\n        border-right: 3px solid white;\n}\n.list-group-item[data-v-143fa953]:first-child {\n        border-radius: 0;\n}\n.helper[data-v-143fa953] {\n        display: inline-block;\n        height: 100%;\n        vertical-align: middle;\n}\n\n    /*\n     * Pasek górny w kolorystyce service-ui: gradient i kolory z tokenów\n     * --header-* (assets/css/theme.css), osobne dla trybu jasnego i ciemnego.\n     * Wysokość zostaje 50px — od niej liczone są wysokości widoków (100vh - 50px).\n     */\n.app-header[data-v-143fa953] {\n        position: relative;\n        z-index: 20;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        gap: 12px;\n        padding: 0 10px;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.14);\n        color: var(--header-fg);\n}\n.app-header__start[data-v-143fa953] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        gap: 12px;\n        min-width: 0;\n        height: 100%;\n}\n.app-header__icon-button[data-v-143fa953] {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -ms-flex-negative: 0;\n            flex-shrink: 0;\n        width: 34px;\n        height: 34px;\n        padding: 0;\n        border: none;\n        border-radius: 8px;\n        background: transparent;\n        color: var(--header-fg);\n        cursor: pointer;\n        -webkit-transition: background-color 0.15s ease;\n        transition: background-color 0.15s ease;\n}\n.app-header__icon-button[data-v-143fa953]:hover {\n        background-color: var(--header-hover);\n}\n.app-header__icon-button svg[data-v-143fa953] {\n        width: 20px;\n        height: 20px;\n        fill: none;\n        stroke: currentColor;\n        stroke-width: 2;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n}\n.app-header__separator[data-v-143fa953] {\n        -ms-flex-negative: 0;\n            flex-shrink: 0;\n        width: 1px;\n        height: 24px;\n        background-color: var(--header-border);\n}\n.app-header__logo[data-v-143fa953] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -ms-flex-negative: 0;\n            flex-shrink: 0;\n}\n.app-header__logo img[data-v-143fa953] {\n        display: block;\n        height: 32px;\n}\n.app-header__context[data-v-143fa953] {\n        overflow: hidden;\n        color: var(--header-fg);\n        font-size: 16px;\n        font-weight: 600;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n}\n.selectedSystemsBackground[data-v-143fa953] {\n      background-color: rgba(0, 125, 149, 1);\n}\n.main-router-view[data-v-143fa953] {\n        background-color: var(--app-bg);\n        width: 100%;\n        overflow-x: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1941:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__ = __webpack_require__(1811);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17837260_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__ = __webpack_require__(1948);
function injectStyle (ssrContext) {
  __webpack_require__(1942)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17837260"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17837260_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1942:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("12ff8a06", content, true, {});

/***/ }),

/***/ 1943:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "#info-container[data-v-17837260]{padding:20px;background:#fff;border:1px solid #efefef;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1);border-radius:5px 0 0 5px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.gallery-container[data-v-17837260]{background:#f9f9f9;-webkit-box-shadow:0 0 40px rgba(53,110,138,.25);box-shadow:0 0 40px rgba(53,110,138,.25);border-radius:5px}.info-field[data-v-17837260]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px}.info-field-title[data-v-17837260]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-17837260]{width:100%;margin:0;padding-bottom:5px}.info-field-value[data-v-17837260]{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}.section-title[data-v-17837260]{font-weight:700}.info-field-row>td[data-v-17837260]{vertical-align:middle}input[type=email][data-v-17837260],input[type=password][data-v-17837260],input[type=text][data-v-17837260]{width:100%;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgb(0 0 0/8%);box-shadow:inset 0 1px 1px rgb(0 0 0/8%)}select[data-v-17837260]{border:none;width:100%}select[data-v-17837260]:focus{outline:none;border-bottom:1px solid #0095b2}option[data-v-17837260]{padding:4px}option[data-v-17837260]:checked{background:#347c93;color:#fff}#notification_chooser[data-v-17837260]{background:#fff;-webkit-box-shadow:inset 0 4px 4px rgba(0,0,0,.25);box-shadow:inset 0 4px 4px rgba(0,0,0,.25);border-radius:4px;margin-top:10px;display:-webkit-box;display:-ms-flexbox;display:flex}#notification_chooser .Inactive_Button[data-v-17837260]{background:none;color:#000;font-weight:bolder}#notification_chooser .Active_Button[data-v-17837260],#notification_chooser .Inactive_Button[data-v-17837260]{-ms-flex-item-align:center;align-self:center;cursor:pointer;border-radius:4px;height:36px;width:100%;margin:3px;-webkit-transition:.8s;transition:.8s;font-size:1.8vh;border:none}#notification_chooser .Active_Button[data-v-17837260]{background:#347c93;color:#fff;font-weight:700}#notification_chooser .Inactive_Button[data-v-17837260]:hover{background:#347C93aa;color:#fff;-webkit-transition-delay:.3ms;transition-delay:.3ms}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Main/EditProfile.vue"],"names":[],"mappings":"AACA,iCACI,aAAc,AAEd,gBAAoB,AACpB,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAAoD,AAC5C,mCAA4C,AACpD,0BAA+B,AAE/B,yBAA0B,AAEtB,sBAAuB,AAEnB,8BAA+B,AACvC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,oCACI,mBAAoB,AACpB,iDAA0D,AAClD,yCAAkD,AAC1D,iBAAmB,CACtB,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,eAAiB,CACpB,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,WAAY,AACZ,SAAU,AACV,kBAAoB,CACvB,AACD,mCACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAElB,aAAe,CAClB,AACD,gCACI,eAAkB,CACrB,AACD,oCACI,qBAAuB,CAC1B,AAGD,2GACI,WAAY,AACZ,sBAAuB,AACvB,kBAAmB,AACnB,iDAAoD,AACpD,wCAA4C,CAC/C,AACD,wBACI,YAAa,AACb,UAAY,CACf,AACD,8BACI,aAAc,AACd,+BAAiC,CACpC,AACD,wBACI,WAAa,CAChB,AACD,gCACI,mBAAoB,AACpB,UAAa,CAChB,AACD,uCACE,gBAAoB,AACpB,mDAA0D,AAClD,2CAAkD,AAC1D,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,wDAGE,gBAAiB,AAQjB,WAAa,AACb,kBAAoB,CAGrB,AACD,8GAfE,2BAA4B,AACxB,kBAAmB,AAEvB,eAAgB,AAChB,kBAAmB,AACnB,YAAa,AACb,WAAY,AACZ,WAAY,AACZ,uBAAyB,AACzB,eAAiB,AAGjB,gBAAiB,AACjB,WAAa,CAiBd,AAfD,sDASE,mBAAoB,AACpB,WAAa,AAEb,eAAkB,CAGnB,AACD,8DACE,qBAAsB,AACtB,WAAa,AACb,8BAAgC,AACxB,qBAAwB,CACjC","file":"EditProfile.vue","sourcesContent":["\n#info-container[data-v-17837260] {\n    padding: 20px;\n\n    background: #FFFFFF;\n    border: 1px solid #EFEFEF;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 5px 0px 0px 5px;\n\n    -webkit-box-pack: justify;\n\n        -ms-flex-pack: justify;\n\n            justify-content: space-between;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.gallery-container[data-v-17837260] {\n    background: #F9F9F9;\n    -webkit-box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n            box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n    border-radius: 5px;\n}\n.info-field[data-v-17837260] {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n.info-field-title[data-v-17837260] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-17837260] {\n    width: 100%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.info-field-value[data-v-17837260] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n}\n.section-title[data-v-17837260] {\n    font-weight: bold;\n}\n.info-field-row > td[data-v-17837260] {\n    vertical-align: middle;\n}\n\n/* Jak w pozostałych modalach z wierszami info-field (AddVersion, SolutionModal…). */\ninput[type=text][data-v-17837260], input[type=\"email\"][data-v-17837260], input[type=\"password\"][data-v-17837260] {\n    width: 100%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\nselect[data-v-17837260] {\n    border: none;\n    width: 100%;\n}\nselect[data-v-17837260]:focus {\n    outline: none;\n    border-bottom: 1px solid #0095b2;\n}\noption[data-v-17837260] {\n    padding: 4px;\n}\noption[data-v-17837260]:checked {\n    background: #347C93;\n    color: white;\n}\n#notification_chooser[data-v-17837260] {\n  background: #ffffff;\n  -webkit-box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n          box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 4px;\n  margin-top: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n#notification_chooser .Inactive_Button[data-v-17837260] {\n  -ms-flex-item-align: center;\n      align-self: center;\n  background: none;\n  cursor: pointer;\n  border-radius: 4px;\n  height: 36px;\n  width: 100%;\n  margin: 3px;\n  -webkit-transition: 0.8s;\n  transition: 0.8s;\n  color: black;\n  font-weight: bolder;\n  font-size: 1.8vh;\n  border: none;\n}\n#notification_chooser .Active_Button[data-v-17837260] {\n  -ms-flex-item-align: center;\n      align-self: center;\n  cursor: pointer;\n  height: 36px;\n  width: 100%;\n  -webkit-transition: 0.8s;\n  transition: 0.8s;\n  margin: 3px;\n  background: #347C93;\n  color: white;\n  border-radius: 4px;\n  font-weight: bold;\n  font-size: 1.8vh;\n  border: none;\n}\n#notification_chooser .Inactive_Button[data-v-17837260]:hover {\n  background: #347C93aa;\n  color: white;\n  -webkit-transition-delay: 0.3ms;\n          transition-delay: 0.3ms;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordModal_vue__ = __webpack_require__(1812);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b88ae1bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordModal_vue__ = __webpack_require__(1947);
function injectStyle (ssrContext) {
  __webpack_require__(1945)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b88ae1bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b88ae1bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1945:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1946);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("74338039", content, true, {});

/***/ }),

/***/ 1946:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".error[data-v-b88ae1bc]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Main/ResetPasswordModal.vue"],"names":[],"mappings":"AACA,wBACI,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC/B","file":"ResetPasswordModal.vue","sourcesContent":["\n.error[data-v-b88ae1bc] {\n    text-align: left !important;\n    color: #FD8282;\n    font-size: 11px;\n    font-weight: bold;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"info-container"}},[_c('div',{staticClass:"vertical"},[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('CurrentPassword')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{attrs:{"id":"rpm-old","type":"password","placeholder":_vm.$t('CurrentPassword')}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('NewPassword')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{attrs:{"id":"rpm-new","type":"password","placeholder":_vm.$t('NewPassword')}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('RepeatNewPassword')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{attrs:{"id":"rpm-repeat","type":"password","placeholder":_vm.$t('RepeatNewPassword')}})])])]),_vm._v(" "),_c('div',[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":'Save',"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-container",staticStyle:{"width":"45vw","min-width":"350px"}},[_c('Modal',{attrs:{"showDialog":_vm.showDialog == 'RESETPWD',"title":_vm.$t('ResetPassword')},on:{"close":_vm.resetPwdClosed}},[_c('reset-password-modal',{attrs:{"email":_vm.user.email},on:{"close":_vm.resetPwdClosed}})],1),_vm._v(" "),_c('div',{attrs:{"id":"info-container"}},[_c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"space-between"}},[_c('p',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('USER_INFORMATION')))]),_vm._v(" "),_c('div',{on:{"click":_vm.openPhotoSelect}},[(_vm.photo != null)?_c('img',{staticStyle:{"width":"34px","height":"34px","border-radius":"50%","margin-right":"10px"},attrs:{"src":_vm.photo}}):_vm._e(),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"id":"file-chooser","type":"file","name":"file","accept":"image/*"},on:{"change":function($event){$event.preventDefault();return _vm.photoChange.apply(null, arguments)}}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Name')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.firstName),expression:"user.firstName"}],attrs:{"type":"text","placeholder":_vm.$t('FirstName')},domProps:{"value":(_vm.user.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "firstName", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Surname')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.surname),expression:"user.surname"}],attrs:{"type":"text","placeholder":_vm.$t('LastName')},domProps:{"value":(_vm.user.surname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "surname", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Email')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],attrs:{"type":"email","placeholder":_vm.$t('Email')},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Password')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('Button',{staticStyle:{"width":"100%"},attrs:{"title":'ChangePassword',"buttonClass":"cancel-button semi-bold"},on:{"onClick":_vm.resetPasswordModal}})],1)])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('PhoneNumber')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phoneNumber),expression:"user.phoneNumber"}],attrs:{"type":"text","placeholder":_vm.$t('PhoneNumber')},domProps:{"value":(_vm.user.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phoneNumber", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Address')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.address),expression:"user.address"}],attrs:{"type":"text","placeholder":_vm.$t('Address')},domProps:{"value":(_vm.user.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "address", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('City')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.city),expression:"user.city"}],attrs:{"type":"text","placeholder":_vm.$t('City')},domProps:{"value":(_vm.user.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "city", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Country')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.country),expression:"user.country"}],attrs:{"type":"text","placeholder":_vm.$t('Country')},domProps:{"value":(_vm.user.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "country", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationMenu_vue__ = __webpack_require__(1813);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d3deb7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationMenu_vue__ = __webpack_require__(1976);
function injectStyle (ssrContext) {
  __webpack_require__(1950)
  __webpack_require__(1952)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19d3deb7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavigationMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d3deb7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavigationMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1950:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1951);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("018d8d32", content, true, {});

/***/ }),

/***/ 1951:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".menu-container[data-v-19d3deb7]{-webkit-transition:.3s ease-out;transition:.3s ease-out;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;background-color:var(--sidebar-bg);height:calc(100vh - 50px);width:250px;overflow:visible}.menu-container_hidden[data-v-19d3deb7]{overflow:hidden}@media only screen and (max-width:700px){.menu-container[data-v-19d3deb7]{position:absolute!important}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Main/Menu/NavigationMenu.vue"],"names":[],"mappings":"AACA,iCACI,gCAAkC,AAClC,wBAA0B,AAG1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,UAAW,AACX,mCAAoC,AACpC,0BAA2B,AAC3B,YAAa,AAIb,gBAAkB,CACrB,AAGD,wCACI,eAAiB,CACpB,AACD,yCACA,iCACQ,2BAA8B,CACrC,CACA","file":"NavigationMenu.vue","sourcesContent":["\n.menu-container[data-v-19d3deb7] {\n    -webkit-transition: 0.3s ease-out;\n    transition: 0.3s ease-out;\n    /* Kolumna, żeby sidebar dostał dokładnie wysokość kontenera, a nie\n       wypchnął zawartość poza ekran. */\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    z-index: 4;\n    background-color: var(--sidebar-bg);\n    height: calc(100vh - 50px);\n    width: 250px;\n    /* Scroll ma sam sidebar (.vsm--scroll-wrapper). Kontener nie może\n       przycinać zawartości, bo w trybie ikon wysuwka z nazwą pozycji\n       wychodzi poza jego szerokość. */\n    overflow: visible;\n}\n\n/* Schowane menu musi przycinać — inaczej etykiety wystają nad treść. */\n.menu-container_hidden[data-v-19d3deb7] {\n    overflow: hidden;\n}\n@media only screen and (max-width: 700px) {\n.menu-container[data-v-19d3deb7] {\n        position: absolute !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1952:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1953);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1e8e448b", content, true, {});

/***/ }),

/***/ 1953:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".menu-container .v-sidebar-menu{--menu-bg:var(--sidebar-bg);--menu-fg:#e5f4f7;--menu-accent:hsla(0,0%,100%,.14);--menu-accent-fg:#fff;--menu-border:hsla(0,0%,100%,.15);--menu-muted:rgba(229,244,247,.55);background-color:var(--menu-bg);color:var(--menu-fg);max-width:100%;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;height:auto;min-height:0}.menu-container .v-sidebar-menu .vsm--scroll-wrapper{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;height:auto;min-height:0;overscroll-behavior:contain;scrollbar-width:thin;scrollbar-color:hsla(0,0%,100%,.28) transparent}.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar{width:6px;height:6px}.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar-track{background:transparent;-webkit-box-shadow:none;box-shadow:none;border:none}.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.22);border-radius:3px}.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar-thumb:hover{background:hsla(0,0%,100%,.38)}.menu-container .v-sidebar-menu .vsm--link{margin:2px 8px;padding:8px 10px;border-radius:8px;font-size:14px;line-height:20px;color:var(--menu-fg)}.menu-container .v-sidebar-menu .vsm--link:hover,.menu-container .v-sidebar-menu .vsm--link_hover{background-color:var(--menu-accent);color:var(--menu-accent-fg)}.menu-container .v-sidebar-menu .vsm--link_active,.menu-container .v-sidebar-menu .vsm--link_exact-active{background-color:var(--menu-accent);color:var(--menu-accent-fg);font-weight:500}.menu-container .v-sidebar-menu .vsm--link_level-1.vsm--link_active,.menu-container .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active{-webkit-box-shadow:none;box-shadow:none}.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1{background-color:transparent}.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1.vsm--link_exact-active,.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1:hover{background-color:var(--menu-accent)}.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon,.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon{background-color:transparent}.menu-container .v-sidebar-menu .vsm--title{margin-left:10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.menu-container .v-sidebar-menu .vsm--link .vsm--icon{width:22px;height:22px;line-height:22px;background-color:transparent;-o-object-fit:contain;object-fit:contain;-ms-flex-negative:0;flex-shrink:0}.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1 .vsm--icon{margin-right:0}.menu-container .v-sidebar-menu .vsm--header{padding:14px 18px 4px;font-size:11px;font-weight:600;letter-spacing:.04em;color:var(--menu-muted);overflow:hidden;text-overflow:ellipsis}.menu-container_with-system .v-sidebar-menu>.vsm--scroll-wrapper>.vsm--list>.vsm--item:first-child{background-color:rgba(0,0,0,.16);border-bottom:1px solid var(--menu-border);padding:4px 0 8px;margin-bottom:8px}.menu-container .v-sidebar-menu .vsm--link_system{font-size:15px;font-weight:600;color:var(--menu-accent-fg)}.menu-container .v-sidebar-menu .vsm--link_system:hover{background-color:var(--menu-accent)}.menu-container .v-sidebar-menu .vsm--dropdown>.vsm--list{padding:2px 0;margin-left:26px;border-left:1px solid var(--menu-border);background-color:transparent}.menu-container .v-sidebar-menu .vsm--dropdown .vsm--link{font-size:13px;padding-left:14px}.menu-container .v-sidebar-menu .vsm--mobile-item{width:calc(var(--menu-width-collapsed) + var(--menu-width))!important;max-width:calc(var(--menu-width-collapsed) + var(--menu-width))!important}.menu-container .v-sidebar-menu .vsm--dropdown_mobile-item,.menu-container .v-sidebar-menu .vsm--mobile-bg,.menu-container .v-sidebar-menu .vsm--mobile-item .vsm--link_mobile-item{background-color:var(--menu-bg);color:var(--menu-fg)}.menu-container .v-sidebar-menu .vsm--dropdown_mobile-item{-webkit-box-shadow:0 8px 24px rgba(0,0,0,.25);box-shadow:0 8px 24px rgba(0,0,0,.25)}.menu-container .v-sidebar-menu .vsm--toggle-btn{height:42px;background-color:transparent;color:var(--menu-muted);border-top:1px solid var(--menu-border)}.menu-container .v-sidebar-menu .vsm--toggle-btn:hover{color:var(--menu-accent-fg);background-color:var(--menu-accent)}.menu-container .v-sidebar-menu .vsm--toggle-btn:after{content:none}.menu-container .v-sidebar-menu .vsm--arrow{width:20px}.vsm-chevron{display:inline-block;width:6px;height:6px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);vertical-align:middle}.vsm-chevron_toggle{-webkit-transform:rotate(135deg);transform:rotate(135deg)}.menu-container .v-sidebar-menu.vsm_collapsed .vsm-chevron_toggle{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Main/Menu/NavigationMenu.vue"],"names":[],"mappings":"AACA,gCACI,4BAA6B,AAC7B,kBAAmB,AACnB,kCAAyC,AACzC,sBAA0B,AAC1B,kCAAyC,AACzC,mCAAwC,AAExC,gCAAiC,AACjC,qBAAsB,AACtB,eAAgB,AAGhB,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,YAAa,AACb,YAAc,CACjB,AAID,qDACI,mBAAoB,AAChB,kBAAmB,AACf,cAAe,AACvB,YAAa,AACb,aAAc,AACd,4BAA6B,AAC7B,qBAAsB,AACtB,+CAAuD,CAC1D,AAID,wEACI,UAAW,AACX,UAAY,CACf,AACD,8EACI,uBAAwB,AACxB,wBAAyB,AACjB,gBAAiB,AACzB,WAAa,CAChB,AACD,8EACI,+BAAsC,AACtC,iBAAmB,CACtB,AACD,oFACI,8BAAsC,CACzC,AACD,2CACI,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,oBAAsB,CACzB,AACD,kGAEI,oCAAqC,AACrC,2BAA6B,CAChC,AACD,0GAEI,oCAAqC,AACrC,4BAA6B,AAC7B,eAAiB,CACpB,AAQD,8IAEI,wBAAyB,AACjB,eAAiB,CAC5B,AAGD,gFACI,4BAA8B,CACjC,AACD,6LAEI,mCAAqC,CACxC,AACD,yQAGI,4BAA8B,CACjC,AACD,4CACI,iBAAkB,AAClB,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACvB,AAGD,sDACI,WAAY,AACZ,YAAa,AACb,iBAAkB,AAClB,6BAA8B,AAC9B,sBAAuB,AACpB,mBAAoB,AACvB,oBAAqB,AACjB,aAAe,CACtB,AAID,iEACI,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,4EACI,cAAgB,CACnB,AACD,6CACI,sBAAuB,AACvB,eAAgB,AAChB,gBAAiB,AACjB,qBAAuB,AACvB,wBAAyB,AACzB,gBAAiB,AACjB,sBAAwB,CAC3B,AAMD,mGACI,iCAAsC,AACtC,2CAA4C,AAC5C,kBAAmB,AACnB,iBAAmB,CACtB,AACD,kDACI,eAAgB,AAChB,gBAAiB,AACjB,2BAA6B,CAChC,AACD,wDACI,mCAAqC,CACxC,AAGD,0DACI,cAAqB,AACrB,iBAAkB,AAClB,yCAA0C,AAC1C,4BAA8B,CACjC,AACD,0DACI,eAAgB,AAChB,iBAAmB,CACtB,AAOD,kDACI,sEAAwE,AACxE,yEAA4E,CAC/E,AACD,oLAGI,gCAAiC,AACjC,oBAAsB,CACzB,AACD,2DACI,8CAAmD,AAC3C,qCAA2C,CACtD,AACD,iDACI,YAAa,AACb,6BAA8B,AAC9B,wBAAyB,AACzB,uCAAyC,CAC5C,AACD,uDACI,4BAA6B,AAC7B,mCAAqC,CACxC,AAGD,uDACI,YAAc,CACjB,AACD,4CACI,UAAY,CACf,AACD,aACI,qBAAsB,AACtB,UAAW,AACX,WAAY,AACZ,sCAAuC,AACvC,uCAAwC,AACxC,iCAAkC,AAC1B,yBAA0B,AAClC,qBAAuB,CAC1B,AACD,oBACI,iCAAkC,AAC1B,wBAA0B,CACrC,AACD,kEACI,iCAAkC,AAC1B,wBAA0B,CACrC","file":"NavigationMenu.vue","sourcesContent":["\n.menu-container .v-sidebar-menu {\n    --menu-bg: var(--sidebar-bg);\n    --menu-fg: #e5f4f7;\n    --menu-accent: rgba(255, 255, 255, 0.14);\n    --menu-accent-fg: #ffffff;\n    --menu-border: rgba(255, 255, 255, 0.15);\n    --menu-muted: rgba(229, 244, 247, 0.55);\n\n    background-color: var(--menu-bg);\n    color: var(--menu-fg);\n    max-width: 100%;\n    /* Menu wypełnia kontener i przewija się w środku — bez tego jego zawartość\n       wychodzi poza ekran i przewijaniem zajmuje się okno przeglądarki. */\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n    height: auto;\n    min-height: 0;\n}\n\n/* Sidebar dzieli wysokość na przewijaną listę i przycisk zwijania. Bez\n   min-height lista rozpycha flexa własną wysokością i wychodzi poza ekran. */\n.menu-container .v-sidebar-menu .vsm--scroll-wrapper {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto;\n    height: auto;\n    min-height: 0;\n    overscroll-behavior: contain;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.28) transparent;\n}\n\n/* Globalny scrollbar aplikacji jest jasny — na ciemnym menu wyglądałby jak\n   doklejony pasek przeglądarki, więc tutaj ma własny, stonowany wygląd. */\n.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n}\n.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar-track {\n    background: transparent;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    border: none;\n}\n.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.22);\n    border-radius: 3px;\n}\n.menu-container .v-sidebar-menu .vsm--scroll-wrapper::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.38);\n}\n.menu-container .v-sidebar-menu .vsm--link {\n    margin: 2px 8px;\n    padding: 8px 10px;\n    border-radius: 8px;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--menu-fg);\n}\n.menu-container .v-sidebar-menu .vsm--link:hover,\n.menu-container .v-sidebar-menu .vsm--link_hover {\n    background-color: var(--menu-accent);\n    color: var(--menu-accent-fg);\n}\n.menu-container .v-sidebar-menu .vsm--link_active,\n.menu-container .v-sidebar-menu .vsm--link_exact-active {\n    background-color: var(--menu-accent);\n    color: var(--menu-accent-fg);\n    font-weight: 500;\n}\n\n/*\n * Motyw paczki (vue-sidebar-menu.css) maluje aktywne i rozwinięte pozycje na\n * niebiesko (#4285f4): tło wiersza, kwadrat pod ikoną i pasek box-shadow po\n * lewej. Jego reguły są mocniejsze od powyższych, więc każdą powtarzamy tu\n * z prefiksem .menu-container — wygrywa niezależnie od kolejności CSS.\n */\n.menu-container .v-sidebar-menu .vsm--link_level-1.vsm--link_active,\n.menu-container .v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active {\n    -webkit-box-shadow: none;\n            box-shadow: none;\n}\n\n/* Pozycja z rozwiniętą listą nie ma tła — inaczej cała gałąź wygląda na aktywną. */\n.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {\n    background-color: transparent;\n}\n.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1:hover,\n.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1.vsm--link_exact-active {\n    background-color: var(--menu-accent);\n}\n.menu-container .v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 .vsm--icon,\n.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,\n.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon {\n    background-color: transparent;\n}\n.menu-container .v-sidebar-menu .vsm--title {\n    margin-left: 10px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* .vsm--link w selektorze, żeby przebić 30px i ciemne tło z .vsm--link_level-1 .vsm--icon paczki. */\n.menu-container .v-sidebar-menu .vsm--link .vsm--icon {\n    width: 22px;\n    height: 22px;\n    line-height: 22px;\n    background-color: transparent;\n    -o-object-fit: contain;\n       object-fit: contain;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n}\n\n/* W trybie ikon wiersz zawiera samą ikonę — centrujemy ją w podświetleniu,\n   zamiast zostawiać przy lewym paddingu z odstępem pod nieobecny tytuł. */\n.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1 {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.menu-container .v-sidebar-menu.vsm_collapsed .vsm--link_level-1 .vsm--icon {\n    margin-right: 0;\n}\n.menu-container .v-sidebar-menu .vsm--header {\n    padding: 14px 18px 4px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    color: var(--menu-muted);\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/*\n * Sekcja systemu to osobny blok na górze menu: ciemniejsze tło i kreska pod\n * spodem oddzielają kontekst otwartego systemu od stałego menu aplikacji.\n */\n.menu-container_with-system .v-sidebar-menu > .vsm--scroll-wrapper > .vsm--list > .vsm--item:first-child {\n    background-color: rgba(0, 0, 0, 0.16);\n    border-bottom: 1px solid var(--menu-border);\n    padding: 4px 0 8px;\n    margin-bottom: 8px;\n}\n.menu-container .v-sidebar-menu .vsm--link_system {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--menu-accent-fg);\n}\n.menu-container .v-sidebar-menu .vsm--link_system:hover {\n    background-color: var(--menu-accent);\n}\n\n/* Poddrzewo: pionowa kreska po lewej, jak w sidebarze shadcn. */\n.menu-container .v-sidebar-menu .vsm--dropdown > .vsm--list {\n    padding: 2px 0 2px 0;\n    margin-left: 26px;\n    border-left: 1px solid var(--menu-border);\n    background-color: transparent;\n}\n.menu-container .v-sidebar-menu .vsm--dropdown .vsm--link {\n    font-size: 13px;\n    padding-left: 14px;\n}\n\n/*\n * Tryb ikon: po najechaniu paczka wysuwa obok sidebara panel z nazwą pozycji\n * i jej poddrzewem. Szerokość liczy z clientWidth kontenera (czyli 65px),\n * dlatego wymuszamy tu pełną szerokość menu; !important bije styl inline.\n */\n.menu-container .v-sidebar-menu .vsm--mobile-item {\n    width: calc(var(--menu-width-collapsed) + var(--menu-width)) !important;\n    max-width: calc(var(--menu-width-collapsed) + var(--menu-width)) !important;\n}\n.menu-container .v-sidebar-menu .vsm--mobile-item .vsm--link_mobile-item,\n.menu-container .v-sidebar-menu .vsm--dropdown_mobile-item,\n.menu-container .v-sidebar-menu .vsm--mobile-bg {\n    background-color: var(--menu-bg);\n    color: var(--menu-fg);\n}\n.menu-container .v-sidebar-menu .vsm--dropdown_mobile-item {\n    -webkit-box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n}\n.menu-container .v-sidebar-menu .vsm--toggle-btn {\n    height: 42px;\n    background-color: transparent;\n    color: var(--menu-muted);\n    border-top: 1px solid var(--menu-border);\n}\n.menu-container .v-sidebar-menu .vsm--toggle-btn:hover {\n    color: var(--menu-accent-fg);\n    background-color: var(--menu-accent);\n}\n\n/* Paczka wstawia w strzałkę i toggle glify Font Awesome, których projekt nie ma. */\n.menu-container .v-sidebar-menu .vsm--toggle-btn:after {\n    content: none;\n}\n.menu-container .v-sidebar-menu .vsm--arrow {\n    width: 20px;\n}\n.vsm-chevron {\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-right: 1.5px solid currentColor;\n    border-bottom: 1.5px solid currentColor;\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg);\n    vertical-align: middle;\n}\n.vsm-chevron_toggle {\n    -webkit-transform: rotate(135deg);\n            transform: rotate(135deg);\n}\n.menu-container .v-sidebar-menu.vsm_collapsed .vsm-chevron_toggle {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1954:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports["vue-sidebar-menu"]=e():t["vue-sidebar-menu"]=e()}(this,(function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,i),o.l=!0,o.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)i.d(n,o,function(e){return t[e]}.bind(null,o));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="/dist/",i(i.s=4)}([function(t,e,i){},function(t,e,i){var n=i(2);t.exports=d,t.exports.parse=s,t.exports.compile=function(t,e){return l(s(t,e))},t.exports.tokensToFunction=l,t.exports.tokensToRegExp=c;var o=new RegExp(["(\\\\.)","([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"].join("|"),"g");function s(t,e){for(var i,n=[],s=0,r=0,l="",m=e&&e.delimiter||"/";null!=(i=o.exec(t));){var u=i[0],c=i[1],d=i.index;if(l+=t.slice(r,d),r=d+u.length,c)l+=c[1];else{var p=t[r],f=i[2],v=i[3],b=i[4],g=i[5],w=i[6],_=i[7];l&&(n.push(l),l="");var C=null!=f&&null!=p&&p!==f,y="+"===w||"*"===w,x="?"===w||"*"===w,I=i[2]||m,S=b||g;n.push({name:v||s++,prefix:f||"",delimiter:I,optional:x,repeat:y,partial:C,asterisk:!!_,pattern:S?h(S):_?".*":"[^"+a(I)+"]+?"})}}return r<t.length&&(l+=t.substr(r)),l&&n.push(l),n}function r(t){return encodeURI(t).replace(/[\/?#]/g,(function(t){return"%"+t.charCodeAt(0).toString(16).toUpperCase()}))}function l(t){for(var e=new Array(t.length),i=0;i<t.length;i++)"object"==typeof t[i]&&(e[i]=new RegExp("^(?:"+t[i].pattern+")$"));return function(i,o){for(var s="",l=i||{},a=(o||{}).pretty?r:encodeURIComponent,h=0;h<t.length;h++){var m=t[h];if("string"!=typeof m){var u,c=l[m.name];if(null==c){if(m.optional){m.partial&&(s+=m.prefix);continue}throw new TypeError('Expected "'+m.name+'" to be defined')}if(n(c)){if(!m.repeat)throw new TypeError('Expected "'+m.name+'" to not repeat, but received `'+JSON.stringify(c)+"`");if(0===c.length){if(m.optional)continue;throw new TypeError('Expected "'+m.name+'" to not be empty')}for(var d=0;d<c.length;d++){if(u=a(c[d]),!e[h].test(u))throw new TypeError('Expected all "'+m.name+'" to match "'+m.pattern+'", but received `'+JSON.stringify(u)+"`");s+=(0===d?m.prefix:m.delimiter)+u}}else{if(u=m.asterisk?encodeURI(c).replace(/[?#]/g,(function(t){return"%"+t.charCodeAt(0).toString(16).toUpperCase()})):a(c),!e[h].test(u))throw new TypeError('Expected "'+m.name+'" to match "'+m.pattern+'", but received "'+u+'"');s+=m.prefix+u}}else s+=m}return s}}function a(t){return t.replace(/([.+*?=^!:${}()[\]|\/\\])/g,"\\$1")}function h(t){return t.replace(/([=!:$\/()])/g,"\\$1")}function m(t,e){return t.keys=e,t}function u(t){return t.sensitive?"":"i"}function c(t,e,i){n(e)||(i=e||i,e=[]);for(var o=(i=i||{}).strict,s=!1!==i.end,r="",l=0;l<t.length;l++){var h=t[l];if("string"==typeof h)r+=a(h);else{var c=a(h.prefix),d="(?:"+h.pattern+")";e.push(h),h.repeat&&(d+="(?:"+c+d+")*"),r+=d=h.optional?h.partial?c+"("+d+")?":"(?:"+c+"("+d+"))?":c+"("+d+")"}}var p=a(i.delimiter||"/"),f=r.slice(-p.length)===p;return o||(r=(f?r.slice(0,-p.length):r)+"(?:"+p+"(?=$))?"),r+=s?"$":o&&f?"":"(?="+p+"|$)",m(new RegExp("^"+r,u(i)),e)}function d(t,e,i){return n(e)||(i=e||i,e=[]),i=i||{},t instanceof RegExp?function(t,e){var i=t.source.match(/\((?!\?)/g);if(i)for(var n=0;n<i.length;n++)e.push({name:n,prefix:null,delimiter:null,optional:!1,repeat:!1,partial:!1,asterisk:!1,pattern:null});return m(t,e)}(t,e):n(t)?function(t,e,i){for(var n=[],o=0;o<t.length;o++)n.push(d(t[o],e,i).source);return m(new RegExp("(?:"+n.join("|")+")",u(i)),e)}(t,e,i):function(t,e,i){return c(s(t,i),e,i)}(t,e,i)}},function(t,e){t.exports=Array.isArray||function(t){return"[object Array]"==Object.prototype.toString.call(t)}},function(t,e,i){"use strict";var n=i(0);i.n(n).a},function(t,e,i){"use strict";i.r(e),i.d(e,"SidebarMenu",(function(){return v}));var n=i(1),o=i.n(n);function s(t,e,i,n,o,s,r,l){var a,h="function"==typeof t?t.options:t;if(e&&(h.render=e,h.staticRenderFns=i,h._compiled=!0),n&&(h.functional=!0),s&&(h._scopeId="data-v-"+s),r?(a=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),o&&o.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},h._ssrRegister=a):o&&(a=l?function(){o.call(this,this.$root.$options.shadowRoot)}:o),a)if(h.functional){h._injectStyles=a;var m=h.render;h.render=function(t,e){return a.call(e),m(t,e)}}else{var u=h.beforeCreate;h.beforeCreate=u?[].concat(u,a):[a]}return{exports:t,options:h}}var r=s({name:"SidebarMenuLink",inheritAttrs:!1,props:{item:{type:Object,required:!0}},computed:{isRouterLink:function(){return!!this.$router&&this.item.href&&!this.item.external},tag:function(){return this.isRouterLink?this.$nuxt?"nuxt-link":"router-link":"a"},href:function(){return this.item.href?this.item.href:"#"}}},(function(){var t=this.$createElement;return(this._self._c||t)(this.tag,this._b({tag:"component"},"component",[this.isRouterLink?{to:this.href}:{href:this.href}].concat(this.$attrs),!1),[this._t("default")],2)}),[],!1,null,null,null);r.options.__file="SidebarMenuLink.vue";var l=r.exports,a=s({name:"SidebarMenuIcon",props:{icon:{type:[String,Object],default:""}}},(function(){var t=this,e=t.$createElement;return(t._self._c||e)(t.icon.element?t.icon.element:"i",t._b({tag:"component",staticClass:"vsm--icon",class:"string"==typeof t.icon||t.icon instanceof String?t.icon:t.icon.class},"component",t.icon.attributes,!1),[t._v("\n  "+t._s(t.icon.text)+"\n")])}),[],!1,null,null,null);a.options.__file="SidebarMenuIcon.vue";var h=a.exports,m=s({name:"SidebarMenuBadge",props:{badge:{type:Object,default:function(){}}}},(function(){var t=this,e=t.$createElement;return(t._self._c||e)(t.badge.element?t.badge.element:"span",t._b({tag:"component",staticClass:"vsm--badge",class:t.badge.class},"component",t.badge.attributes,!1),[t._v("\n  "+t._s(t.badge.text)+"\n")])}),[],!1,null,null,null);m.options.__file="SidebarMenuBadge.vue";var u=m.exports,c=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var n in i)Object.prototype.hasOwnProperty.call(i,n)&&(t[n]=i[n])}return t},d=s({name:"SidebarMenuItem",components:{SidebarMenuLink:l,SidebarMenuIcon:h,SidebarMenuBadge:u},props:{item:{type:Object,required:!0},level:{type:Number,default:1},isCollapsed:{type:Boolean},isMobileItem:{type:Boolean,default:!1},mobileItem:{type:Object,default:null},activeShow:{type:Object,default:null},showChild:{type:Boolean,default:!1},showOneChild:{type:Boolean,default:!1},rtl:{type:Boolean,default:!1},disableHover:{type:Boolean,default:!1},mobileItemStyle:{type:Object,default:null}},data:function(){return{active:!1,exactActive:!1,itemShow:!1,itemHover:!1}},computed:{isFirstLevel:function(){return 1===this.level},show:{get:function(){return!!this.itemHasChild&&(!(!this.showChild&&!this.isMobileItem)||this.itemShow)},set:function(t){this.showOneChild&&(t?this.emitActiveShow(this.item):this.emitActiveShow(null)),this.itemShow=t}},itemLinkClass:function(){return["vsm--link",this.isMobileItem?"":"vsm--link_level-"+this.level,{"vsm--link_mobile-item":this.isMobileItem},{"vsm--link_hover":this.hover},{"vsm--link_active":this.active},{"vsm--link_exact-active":this.exactActive},{"vsm--link_disabled":this.item.disabled},this.item.class]},itemLinkAttributes:function(){var t=this.item.external?"_blank":"_self",e=this.item.disabled?-1:null;return c({target:t,tabindex:e},this.item.attributes)},isItemHidden:function(){return this.isCollapsed?!(!this.item.hidden||void 0!==this.item.hiddenOnCollapse)||!0===this.item.hiddenOnCollapse:!0===this.item.hidden},hover:function(){return this.isCollapsed&&this.isFirstLevel?this.item===this.mobileItem:this.itemHover},itemHasChild:function(){return!!(this.item.child&&this.item.child.length>0)}},watch:{$route:function(){var t=this;setTimeout((function(){t.item.header||t.item.component||t.initState()}),1)},item:function(t,e){this.emitItemUpdate(t,e)},activeShow:function(){this.itemShow=this.item===this.activeShow}},created:function(){this.item.header||this.item.component||this.initState()},mounted:function(){this.$router||window.addEventListener("hashchange",this.initState)},destroyed:function(){this.$router||window.removeEventListener("hashchange",this.initState)},methods:{isLinkActive:function(t){return this.matchRoute(t)||this.isChildActive(t.child)||this.isAliasActive(t)},isLinkExactActive:function(t){return this.matchExactRoute(t.href)},isChildActive:function(t){var e=this;return!!t&&t.some((function(t){return e.isLinkActive(t)}))},isAliasActive:function(t){if(t.alias){var e=this.$router?this.$route.fullPath:window.location.pathname+window.location.search+window.location.hash;return Array.isArray(t.alias)?t.alias.some((function(t){return o()(t).test(e)})):o()(t.alias).test(e)}return!1},matchRoute:function(t){var e=t.href,i=t.exactPath;if(!e)return!1;if(this.$router){var n=this.$router.resolve(e).route;return i?n.path===this.$route.path:this.matchExactRoute(e)}return i?e===window.location.pathname:this.matchExactRoute(e)},matchExactRoute:function(t){return!!t&&(this.$router?this.$router.resolve(t).route.fullPath===this.$route.fullPath:t===window.location.pathname+window.location.search+window.location.hash)},clickEvent:function(t){this.item.disabled||(this.item.href||t.preventDefault(),this.emitItemClick(t,this.item,this),this.emitMobileItem(t,t.currentTarget.offsetParent),!this.itemHasChild||this.showChild||this.isMobileItem||this.item.href&&!this.exactActive||(this.show=!this.show))},emitMobileItem:function(t,e){var i=this;this.hover||this.isCollapsed&&this.isFirstLevel&&!this.isMobileItem&&(this.$emit("unset-mobile-item",!0),setTimeout((function(){i.mobileItem!==i.item&&i.$emit("set-mobile-item",{item:i.item,itemEl:e}),"click"!==t.type||i.itemHasChild||i.$emit("unset-mobile-item",!1)}),0))},initState:function(){this.initActiveState(),this.initShowState()},initActiveState:function(){this.active=this.isLinkActive(this.item),this.exactActive=this.isLinkExactActive(this.item)},initShowState:function(){this.itemHasChild&&!this.showChild&&(this.showOneChild&&this.active&&!this.show||this.active&&!this.show?this.show=!0:this.showOneChild&&!this.active&&this.show&&(this.show=!1))},mouseOverEvent:function(t){this.item.disabled||(t.stopPropagation(),this.itemHover=!0,this.disableHover||this.emitMobileItem(t,t.currentTarget))},mouseOutEvent:function(t){t.stopPropagation(),this.itemHover=!1},expandEnter:function(t){t.style.height=t.scrollHeight+"px"},expandAfterEnter:function(t){t.style.height="auto"},expandBeforeLeave:function(t){this.isCollapsed&&this.isFirstLevel?t.style.display="none":t.style.height=t.scrollHeight+"px"}},inject:["emitActiveShow","emitItemClick","emitItemUpdate"]},(function(){var t=this,e=t.$createElement,i=t._self._c||e;return t.item.component&&!t.isItemHidden?i(t.item.component,t._b({tag:"component"},"component",t.item.props,!1)):t.item.header&&!t.isItemHidden?i("div",t._b({staticClass:"vsm--header",class:t.item.class},"div",t.item.attributes,!1),[t._v("\n  "+t._s(t.item.title)+"\n")]):t.isItemHidden?t._e():i("div",{staticClass:"vsm--item",class:[{"vsm--item_open":t.show}],on:{mouseover:t.mouseOverEvent,mouseout:t.mouseOutEvent}},[i("sidebar-menu-link",t._b({class:t.itemLinkClass,attrs:{item:t.item},nativeOn:{click:function(e){return t.clickEvent(e)}}},"sidebar-menu-link",t.itemLinkAttributes,!1),[t.item.icon&&!t.isMobileItem?i("sidebar-menu-icon",{attrs:{icon:t.item.icon}}):t._e(),t._v(" "),i("transition",{attrs:{name:"fade-animation",appear:t.isMobileItem}},[t.isCollapsed&&!t.isFirstLevel||!t.isCollapsed||t.isMobileItem?[i("span",{staticClass:"vsm--title"},[t._v(t._s(t.item.title))])]:t._e()],2),t._v(" "),t.isCollapsed&&!t.isFirstLevel||!t.isCollapsed||t.isMobileItem?[t.item.badge?i("sidebar-menu-badge",{attrs:{badge:t.item.badge}}):t._e(),t._v(" "),t.itemHasChild?i("div",{staticClass:"vsm--arrow",class:[{"vsm--arrow_open":t.show},{"vsm--arrow_slot":t.$slots["dropdown-icon"]}]},[t._t("dropdown-icon")],2):t._e()]:t._e()],2),t._v(" "),t.itemHasChild?[t.isCollapsed&&!t.isFirstLevel||!t.isCollapsed||t.isMobileItem?[i("transition",{attrs:{appear:t.isMobileItem,name:"expand"},on:{enter:t.expandEnter,afterEnter:t.expandAfterEnter,beforeLeave:t.expandBeforeLeave}},[t.show?i("div",{staticClass:"vsm--dropdown",class:t.isMobileItem&&"vsm--dropdown_mobile-item",style:t.isMobileItem&&t.mobileItemStyle.dropdown},[i("div",{staticClass:"vsm--list"},t._l(t.item.child,(function(e,n){return i("sidebar-menu-item",{key:n,attrs:{item:e,level:t.level+1,"show-child":t.showChild,rtl:t.rtl,"is-collapsed":t.isCollapsed}},[t._t("dropdown-icon",null,{slot:"dropdown-icon"})],2)})),1)]):t._e()])]:t._e()]:t._e()],2)}),[],!1,null,null,null);d.options.__file="SidebarMenuItem.vue";var p={name:"SidebarMenu",components:{SidebarMenuItem:d.exports},props:{menu:{type:Array,required:!0},collapsed:{type:Boolean,default:!1},width:{type:String,default:"350px"},widthCollapsed:{type:String,default:"50px"},showChild:{type:Boolean,default:!1},theme:{type:String,default:""},showOneChild:{type:Boolean,default:!1},rtl:{type:Boolean,default:!1},relative:{type:Boolean,default:!1},hideToggle:{type:Boolean,default:!1},disableHover:{type:Boolean,default:!1}},data:function(){return{isCollapsed:this.collapsed,mobileItem:null,mobileItemPos:0,mobileItemHeight:0,mobileItemTimeout:null,activeShow:null,parentHeight:0,parentWidth:0,parentOffsetTop:0,parentOffsetLeft:0}},computed:{sidebarWidth:function(){return this.isCollapsed?this.widthCollapsed:this.width},sidebarClass:function(){return[this.isCollapsed?"vsm_collapsed":"vsm_expanded",this.theme?"vsm_"+this.theme:"",this.rtl?"vsm_rtl":"",this.relative?"vsm_relative":""]},mobileItemStyle:function(){return{item:[{position:"absolute"},{top:this.mobileItemPos+"px"},this.rtl?{right:"0px"}:{left:"0px"},this.rtl?{"padding-right":this.sidebarWidth}:{"padding-left":this.sidebarWidth},this.rtl&&{direction:"rtl"},{"z-index":0},{width:this.parentWidth-this.parentOffsetLeft+"px"},{"max-width":this.width}],dropdown:[{position:"absolute"},{top:this.mobileItemHeight+"px"},{width:"100%"},{"max-height":this.parentHeight-(this.mobileItemPos+this.mobileItemHeight)-this.parentOffsetTop+"px"},{"overflow-y":"auto"}],background:[{position:"absolute"},{top:"0px"},{left:"0px"},{right:"0px"},{width:"100%"},{height:this.mobileItemHeight+"px"},{"z-index":-1}]}}},watch:{collapsed:function(t){this.isCollapsed!==this.collapsed&&(this.isCollapsed=t,this.mobileItem=null)}},methods:{onMouseLeave:function(){this.unsetMobileItem(!1,300)},onMouseEnter:function(){this.isCollapsed&&this.mobileItemTimeout&&clearTimeout(this.mobileItemTimeout)},onToggleClick:function(){this.isCollapsed=!this.isCollapsed,this.mobileItem=null,this.$emit("toggle-collapse",this.isCollapsed)},onActiveShow:function(t){this.activeShow=t},onItemClick:function(t,e,i){this.$emit("item-click",t,e,i)},setMobileItem:function(t){var e=t.item,i=t.itemEl;if(this.mobileItem!==e){var n=this.$el.getBoundingClientRect().top,o=i.children[0].getBoundingClientRect(),s=o.top,r=o.height,l=s-n;this.initParentOffsets(),this.mobileItem=e,this.mobileItemPos=l,this.mobileItemHeight=r}},unsetMobileItem:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:800;this.mobileItem&&(this.mobileItemTimeout&&clearTimeout(this.mobileItemTimeout),t?this.mobileItem=null:this.mobileItemTimeout=setTimeout((function(){e.mobileItem=null}),i))},initParentOffsets:function(){var t=this.$el.getBoundingClientRect(),e=t.top,i=t.left,n=t.right,o=this.relative?this.$el.parentElement:document.documentElement;if(this.parentHeight=o.clientHeight,this.parentWidth=o.clientWidth,this.relative){var s=o.getBoundingClientRect(),r=s.top,l=s.left;this.parentOffsetTop=e-(r+o.clientTop),this.parentOffsetLeft=this.rtl?this.parentWidth-n+(l+o.clientLeft):i-(l+o.clientLeft)}else this.parentOffsetTop=e,this.parentOffsetLeft=this.rtl?this.parentWidth-n:i},onItemUpdate:function(t,e){e===this.mobileItem&&(this.mobileItem=t),e===this.activeShow&&(this.activeShow=t)}},provide:function(){return{emitActiveShow:this.onActiveShow,emitItemClick:this.onItemClick,emitItemUpdate:this.onItemUpdate}}},f=(i(3),s(p,(function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"v-sidebar-menu",class:t.sidebarClass,style:[{"max-width":t.sidebarWidth}],on:{mouseleave:t.onMouseLeave,mouseenter:t.onMouseEnter}},[t._t("header"),t._v(" "),i("div",{staticClass:"vsm--scroll-wrapper",style:t.isCollapsed&&[t.rtl?{"margin-left":"-17px"}:{"margin-right":"-17px"}]},[i("div",{staticClass:"vsm--list",style:t.isCollapsed&&{width:t.widthCollapsed}},t._l(t.menu,(function(e,n){return i("sidebar-menu-item",{key:n,attrs:{item:e,"is-collapsed":t.isCollapsed,"active-show":t.activeShow,"show-one-child":t.showOneChild,"show-child":t.showChild,rtl:t.rtl,"mobile-item":t.mobileItem,"disable-hover":t.disableHover},on:{"set-mobile-item":t.setMobileItem,"unset-mobile-item":t.unsetMobileItem}},[t._t("dropdown-icon",null,{slot:"dropdown-icon"})],2)})),1),t._v(" "),t.isCollapsed?i("div",{staticClass:"vsm--mobile-item",style:t.mobileItemStyle.item},[t.mobileItem?i("sidebar-menu-item",{attrs:{item:t.mobileItem,"is-mobile-item":!0,"mobile-item-style":t.mobileItemStyle,"is-collapsed":t.isCollapsed,"show-child":t.showChild,rtl:t.rtl,"disable-hover":t.disableHover}},[t._t("dropdown-icon",null,{slot:"dropdown-icon"})],2):t._e(),t._v(" "),i("transition",{attrs:{name:"slide-animation"}},[t.mobileItem?i("div",{staticClass:"vsm--mobile-bg",style:t.mobileItemStyle.background}):t._e()])],1):t._e()]),t._v(" "),t._t("footer"),t._v(" "),t.hideToggle?t._e():i("button",{staticClass:"vsm--toggle-btn",class:{"vsm--toggle-btn_slot":t.$slots["toggle-icon"]},on:{click:t.onToggleClick}},[t._t("toggle-icon")],2)],2)}),[],!1,null,null,null));f.options.__file="SidebarMenu.vue";var v=f.exports;e.default={install:function(t){t.component("sidebar-menu",v)}}}])}));
//# sourceMappingURL=vue-sidebar-menu.js.map

/***/ }),

/***/ 1955:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDI5QzE3LjczNDUgMjkgMTkuMTQxNCAyNy42MDExIDE5LjE0MTQgMjUuODc1SDEyLjg1ODdDMTIuODU4NyAyNy42MDExIDE0LjI2NTYgMjkgMTYgMjlaTTI2LjU3NzIgMjEuNjg5OUMyNS42Mjg1IDIwLjY3NjMgMjMuODUzMyAxOS4xNTE0IDIzLjg1MzMgMTQuMTU2MkMyMy44NTMzIDEwLjM2MjMgMjEuMTc3OSA3LjMyNTIgMTcuNTcwNSA2LjU4MDA4VjUuNTYyNUMxNy41NzA1IDQuNjk5NzEgMTYuODY3MyA0IDE2IDRDMTUuMTMyOCA0IDE0LjQyOTYgNC42OTk3MSAxNC40Mjk2IDUuNTYyNVY2LjU4MDA4QzEwLjgyMjIgNy4zMjUyIDguMTQ2ODIgMTAuMzYyMyA4LjE0NjgyIDE0LjE1NjJDOC4xNDY4MiAxOS4xNTE0IDYuMzcxNiAyMC42NzYzIDUuNDIyODUgMjEuNjg5OUM1LjEyODIgMjIuMDA0OSA0Ljk5NzU4IDIyLjM4MTMgNS4wMDAwMyAyMi43NUM1LjAwNTQ0IDIzLjU1MDggNS42Mzc0NCAyNC4zMTI1IDYuNTc2MzcgMjQuMzEyNUgyNS40MjM3QzI2LjM2MjYgMjQuMzEyNSAyNi45OTUxIDIzLjU1MDggMjcgMjIuNzVDMjcuMDAyNSAyMi4zODEzIDI2Ljg3MTkgMjIuMDA0NCAyNi41NzcyIDIxLjY4OTlWMjEuNjg5OVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 1956:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1957:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMSAyMUg2LjJDNS4wNzk4OSAyMSA0LjUxOTg0IDIxIDQuMDkyMDIgMjAuNzgyQzMuNzE1NjkgMjAuNTkwMyAzLjQwOTczIDIwLjI4NDMgMy4yMTc5OSAxOS45MDhDMyAxOS40ODAyIDMgMTguOTIwMSAzIDE3LjhWM003IDE1TDEyIDlMMTYgMTNMMjEgNyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg=="

/***/ }),

/***/ 1958:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMiAxNlYyMk0xMiAxNkwxNCAxOE0xMiAxNkwxMCAxOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTIyIDEzLjM1MjlDMjIgMTUuNjk1OCAyMC41NTYyIDE3LjcwNTUgMTguNSAxOC41NjA0TTE0LjM4MSA4LjAyNzIxQzE0Ljk3NjcgNy44MTkxMSAxNS42MTc4IDcuNzA1ODggMTYuMjg1NyA3LjcwNTg4QzE2Ljk0MDQgNy43MDU4OCAxNy41NjkzIDcuODE0NjggMTguMTU1MSA4LjAxNDk4TTcuMTE2MTYgMTAuNjA4OUM2Ljg0NzUgMTAuNTU2NyA2LjU2OTgzIDEwLjUyOTQgNi4yODU3MSAxMC41Mjk0QzMuOTE4NzggMTAuNTI5NCAyIDEyLjQyNTYgMiAxNC43NjQ3QzIgMTYuNjYxMSAzLjI2MTI0IDE4LjI2NjQgNSAxOC44MDYxTTcuMTE2MTYgMTAuNjA4OUM2Ljg4NzA2IDkuOTk3OCA2Ljc2MTkgOS4zMzY4NyA2Ljc2MTkgOC42NDcwNkM2Ljc2MTkgNS41MjgyNyA5LjMyMDI4IDMgMTIuNDc2MiAzQzE1LjQxNTkgMyAxNy44MzcxIDUuMTkzNzEgMTguMTU1MSA4LjAxNDk4TTcuMTE2MTYgMTAuNjA4OUM3LjY4MDU5IDEwLjcxODQgOC4yMDUyOCAxMC45Mzc0IDguNjY2NjcgMTEuMjQyNk0xOC4xNTUxIDguMDE0OThDMTkuMDQ0NiA4LjMxOTE2IDE5LjgzNDUgOC44MzQzNiAyMC40NjMzIDkuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPC9zdmc+"

/***/ }),

/***/ 1959:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1960:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzExNV8yKSI+CjxwYXRoIGQ9Ik0yMyAxSDJDMS40NDc3MiAxIDEgMS40NDc3MiAxIDJWMjBDMSAyMC41NTIzIDEuNDQ3NzIgMjEgMiAyMUgyM0MyMy41NTIzIDIxIDI0IDIwLjU1MjMgMjQgMjBWMkMyNCAxLjQ0NzcyIDIzLjU1MjMgMSAyMyAxWiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xMC43MzkxIDRINS4yNjA4N0M1LjExNjggNCA1IDQuMTExOTMgNSA0LjI1VjguNzVDNSA4Ljg4ODA3IDUuMTE2OCA5IDUuMjYwODcgOUgxMC43MzkxQzEwLjg4MzIgOSAxMSA4Ljg4ODA3IDExIDguNzVWNC4yNUMxMSA0LjExMTkzIDEwLjg4MzIgNCAxMC43MzkxIDRaIiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xOS43MzkxIDRIMTQuMjYwOUMxNC4xMTY4IDQgMTQgNC4xMTE5MyAxNCA0LjI1VjguNzVDMTQgOC44ODgwNyAxNC4xMTY4IDkgMTQuMjYwOSA5SDE5LjczOTFDMTkuODgzMiA5IDIwIDguODg4MDcgMjAgOC43NVY0LjI1QzIwIDQuMTExOTMgMTkuODgzMiA0IDE5LjczOTEgNFoiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTEwLjczOTEgMTNINS4yNjA4N0M1LjExNjggMTMgNSAxMy4xMTE5IDUgMTMuMjVWMTcuNzVDNSAxNy44ODgxIDUuMTE2OCAxOCA1LjI2MDg3IDE4SDEwLjczOTFDMTAuODgzMiAxOCAxMSAxNy44ODgxIDExIDE3Ljc1VjEzLjI1QzExIDEzLjExMTkgMTAuODgzMiAxMyAxMC43MzkxIDEzWiIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzExNV8yIj4KPHJlY3Qgd2lkdGg9IjI1IiBoZWlnaHQ9IjIyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),

/***/ 1961:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjI2OTIgNEg0LjczMDc3QzQuMzI3MTggNCA0IDQuMzgzNzYgNCA0Ljg1NzE0VjE1LjE0MjlDNCAxNS42MTYyIDQuMzI3MTggMTYgNC43MzA3NyAxNkgyMi4yNjkyQzIyLjY3MjggMTYgMjMgMTUuNjE2MiAyMyAxNS4xNDI5VjQuODU3MTRDMjMgNC4zODM3NiAyMi42NzI4IDQgMjIuMjY5MiA0WiIgc3Ryb2tlPSIjMzQ2RjhCIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC41IDEyQzE5LjMyODQgMTIgMjAgMTEuMzI4NCAyMCAxMC41QzIwIDkuNjcxNTcgMTkuMzI4NCA5IDE4LjUgOUMxNy42NzE2IDkgMTcgOS42NzE1NyAxNyAxMC41QzE3IDExLjMyODQgMTcuNjcxNiAxMiAxOC41IDEyWiIgZmlsbD0iIzM0NkY4QiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 1962:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDI0QzE2LjgyODQgMjQgMTcuNSAyMy4zMjg0IDE3LjUgMjIuNUMxNy41IDIxLjY3MTYgMTYuODI4NCAyMSAxNiAyMUMxNS4xNzE2IDIxIDE0LjUgMjEuNjcxNiAxNC41IDIyLjVDMTQuNSAyMy4zMjg0IDE1LjE3MTYgMjQgMTYgMjRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTYgMTguMDAwNVYxNy4wMDA1QzE2LjY5MjIgMTcuMDAwNSAxNy4zNjg5IDE2Ljc5NTIgMTcuOTQ0NSAxNi40MTA2QzE4LjUyMDEgMTYuMDI2IDE4Ljk2ODcgMTUuNDc5NCAxOS4yMzM2IDE0LjgzOTlDMTkuNDk4NSAxNC4yMDAzIDE5LjU2NzggMTMuNDk2NiAxOS40MzI3IDEyLjgxNzdDMTkuMjk3NyAxMi4xMzg3IDE4Ljk2NDQgMTEuNTE1MSAxOC40NzQ5IDExLjAyNTZDMTcuOTg1NCAxMC41MzYxIDE3LjM2MTggMTAuMjAyOCAxNi42ODI4IDEwLjA2NzdDMTYuMDAzOSA5LjkzMjY5IDE1LjMwMDEgMTAuMDAyIDE0LjY2MDYgMTAuMjY2OUMxNC4wMjExIDEwLjUzMTggMTMuNDc0NCAxMC45ODA0IDEzLjA4OTkgMTEuNTU2QzEyLjcwNTMgMTIuMTMxNiAxMi41IDEyLjgwODMgMTIuNSAxMy41MDA1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ 1963:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgMy4yNUMzLjUzMzUxIDMuMjUgMi43NSA0LjAzMzUxIDIuNzUgNVYxNUMyLjc1IDE1Ljk2NjUgMy41MzM1MSAxNi43NSA0LjUgMTYuNzVIMjIuNUMyMy40NjY1IDE2Ljc1IDI0LjI1IDE1Ljk2NjUgMjQuMjUgMTVWNUMyNC4yNSA0LjAzMzUxIDIzLjQ2NjUgMy4yNSAyMi41IDMuMjVINC41Wk00LjI1IDVDNC4yNSA0Ljg2MTkzIDQuMzYxOTMgNC43NSA0LjUgNC43NUgyMi41QzIyLjYzODEgNC43NSAyMi43NSA0Ljg2MTkzIDIyLjc1IDVWNS4zNjg1MkwxMy41IDExLjA5NjNMNC4yNSA1LjM2ODUyVjVaTTQuMjUgNy4xMzE0OFYxNUM0LjI1IDE1LjEzODEgNC4zNjE5MyAxNS4yNSA0LjUgMTUuMjVIMjIuNUMyMi42MzgxIDE1LjI1IDIyLjc1IDE1LjEzODEgMjIuNzUgMTVWNy4xMzE0OEwxMy44OTUgMTIuNjE1MkMxMy42NTI4IDEyLjc2NTIgMTMuMzQ3MiAxMi43NjUyIDEzLjEwNSAxMi42MTUyTDQuMjUgNy4xMzE0OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 1964:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQzNzUgMTYuODEyNUMxOC4zMDE1IDE2LjgxMjUgMTkuODEyNSAxNS4zMDE1IDE5LjgxMjUgMTMuNDM3NUMxOS44MTI1IDExLjU3MzUgMTguMzAxNSAxMC4wNjI1IDE2LjQzNzUgMTAuMDYyNUMxNC41NzM1IDEwLjA2MjUgMTMuMDYyNSAxMS41NzM1IDEzLjA2MjUgMTMuNDM3NUMxMy4wNjI1IDE1LjMwMTUgMTQuNTczNSAxNi44MTI1IDE2LjQzNzUgMTYuODEyNVoiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNC44NzUgMTMuNDM3NUMyNC44NzUgMjEuMDMxMiAxNi40Mzc1IDI2LjkzNzUgMTYuNDM3NSAyNi45Mzc1QzE2LjQzNzUgMjYuOTM3NSA4IDIxLjAzMTIgOCAxMy40Mzc1QzggMTEuMTk5NyA4Ljg4ODk1IDkuMDUzNjIgMTAuNDcxMyA3LjQ3MTI5QzEyLjA1MzYgNS44ODg5NSAxNC4xOTk3IDUgMTYuNDM3NSA1QzE4LjY3NTMgNSAyMC44MjE0IDUuODg4OTUgMjIuNDAzNyA3LjQ3MTI5QzIzLjk4NjEgOS4wNTM2MiAyNC44NzUgMTEuMTk5NyAyNC44NzUgMTMuNDM3NVYxMy40Mzc1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1965:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1966:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1967:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1968:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1969:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1970:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1971:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDRINUM0LjIwNDM1IDQgMy40NDEyOSA0LjMxNjA3IDIuODc4NjggNC44Nzg2OEMyLjMxNjA3IDUuNDQxMjkgMiA2LjIwNDM1IDIgN1YxN0MyIDE3Ljc5NTYgMi4zMTYwNyAxOC41NTg3IDIuODc4NjggMTkuMTIxM0MzLjQ0MTI5IDE5LjY4MzkgNC4yMDQzNSAyMCA1IDIwSDE5QzE5Ljc5NTYgMjAgMjAuNTU4NyAxOS42ODM5IDIxLjEyMTMgMTkuMTIxM0MyMS42ODM5IDE4LjU1ODcgMjIgMTcuNzk1NiAyMiAxN1Y3QzIyIDYuMjA0MzUgMjEuNjgzOSA1LjQ0MTI5IDIxLjEyMTMgNC44Nzg2OEMyMC41NTg3IDQuMzE2MDcgMTkuNzk1NiA0IDE5IDRWNFpNMTguNTkgNkwxMi43MSAxMS44OEMxMi42MTcgMTEuOTczNyAxMi41MDY0IDEyLjA0ODEgMTIuMzg0NiAxMi4wOTg5QzEyLjI2MjcgMTIuMTQ5NyAxMi4xMzIgMTIuMTc1OCAxMiAxMi4xNzU4QzExLjg2OCAxMi4xNzU4IDExLjczNzMgMTIuMTQ5NyAxMS42MTU0IDEyLjA5ODlDMTEuNDkzNiAxMi4wNDgxIDExLjM4MyAxMS45NzM3IDExLjI5IDExLjg4TDUuNDEgNkgxOC41OVpNMjAgMTdDMjAgMTcuMjY1MiAxOS44OTQ2IDE3LjUxOTYgMTkuNzA3MSAxNy43MDcxQzE5LjUxOTYgMTcuODk0NiAxOS4yNjUyIDE4IDE5IDE4SDVDNC43MzQ3OCAxOCA0LjQ4MDQzIDE3Ljg5NDYgNC4yOTI4OSAxNy43MDcxQzQuMTA1MzYgMTcuNTE5NiA0IDE3LjI2NTIgNCAxN1Y3LjQxTDkuODggMTMuMjlDMTAuNDQyNSAxMy44NTE4IDExLjIwNSAxNC4xNjc0IDEyIDE0LjE2NzRDMTIuNzk1IDE0LjE2NzQgMTMuNTU3NSAxMy44NTE4IDE0LjEyIDEzLjI5TDIwIDcuNDFWMTdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"

/***/ }),

/***/ 1972:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnPgogICAgICAgIDxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSJyZWQiIGQ9Ik0xNyAyaDNhMSAxIDAgMCAxIDEgMXYxOGExIDEgMCAwIDEtMSAxSDRhMSAxIDAgMCAxLTEtMVYzYTEgMSAwIDAgMSAxLTFoM1YwaDJ2Mmg2VjBoMnYyem0wIDJ2MmgtMlY0SDl2Mkg3VjRINXYxNmgxNFY0aC0yek03IDhoMTB2Mkg3Vjh6bTAgNGgxMHYySDd2LTJ6Ii8+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 1973:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhLS0gVXBsb2FkZWQgdG86IFNWRyBSZXBvLCB3d3cuc3ZncmVwby5jb20sIEdlbmVyYXRvcjogU1ZHIFJlcG8gTWl4ZXIgVG9vbHMgLS0+Cgo8c3ZnIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwaDI0djI0SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSJncmVlbiIgZD0ibSAxNywyIGggMyBjIDAuNTUyMjg1LDAgMSwwLjQ0NzcxNTMgMSwxIHYgMTggYyAwLDAuNTUyMjg1IC0wLjQ0NzcxNSwxIC0xLDEgSCA0IEMgMy40NDc3MTUzLDIyIDMsMjEuNTUyMjg1IDMsMjEgViAzIEMgMywyLjQ0NzcxNTMgMy40NDc3MTUzLDIgNCwyIEggNyBWIDAgaCAyIHYgMiBoIDYgViAwIGggMiB6IG0gMCwyIFYgNiBIIDE1IFYgNCBIIDkgViA2IEggNyBWIDQgSCA1IFYgMjAgSCAxOSBWIDQgWiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 1974:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnPgogICAgICAgIDxwYXRoIGZpbGw9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSJ3aGl0ZSIgZD0iTTE3IDJoM2ExIDEgMCAwIDEgMSAxdjE4YTEgMSAwIDAgMS0xIDFINGExIDEgMCAwIDEtMS0xVjNhMSAxIDAgMCAxIDEtMWgzVjBoMnYyaDZWMGgydjJ6bTAgMnYyaC0yVjRIOXYySDdWNEg1djE2aDE0VjRoLTJ6TTcgOGgxMHYySDdWOHptMCA0aDEwdjJIN3YtMnoiLz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 1975:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjkzNzUgMTkuMjVDMTQuODU0MyAxOS4yNSAxNy4yMTg4IDE2Ljg4NTUgMTcuMjE4OCAxMy45Njg4QzE3LjIxODggMTEuMDUyIDE0Ljg1NDMgOC42ODc1IDExLjkzNzUgOC42ODc1QzkuMDIwNzUgOC42ODc1IDYuNjU2MjUgMTEuMDUyIDYuNjU2MjUgMTMuOTY4OEM2LjY1NjI1IDE2Ljg4NTUgOS4wMjA3NSAxOS4yNSAxMS45Mzc1IDE5LjI1WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4KPHBhdGggZD0iTTE4Ljc4NDIgOC44ODQ0NkMxOS41MTA2IDguNjc5OCAyMC4yNzI0IDguNjMzMTcgMjEuMDE4MyA4Ljc0NzczQzIxLjc2NDMgOC44NjIyOCAyMi40NzcgOS4xMzUzNiAyMy4xMDg1IDkuNTQ4NTZDMjMuNzQgOS45NjE3NiAyNC4yNzU2IDEwLjUwNTUgMjQuNjc5MyAxMS4xNDMxQzI1LjA4MyAxMS43ODA4IDI1LjM0NTMgMTIuNDk3NSAyNS40NDg3IDEzLjI0NTFDMjUuNTUyIDEzLjk5MjYgMjUuNDk0IDE0Ljc1MzcgMjUuMjc4NCAxNS40NzY5QzI1LjA2MjkgMTYuMjAwMiAyNC42OTQ5IDE2Ljg2ODggMjQuMTk5MSAxNy40Mzc4QzIzLjcwMzQgMTguMDA2OSAyMy4wOTE1IDE4LjQ2MzEgMjIuNDA0NiAxOC43NzU3QzIxLjcxNzggMTkuMDg4MyAyMC45NzE5IDE5LjI1MDEgMjAuMjE3MiAxOS4yNTAyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC42MjQ1MSAyMy4wNDgxQzUuNDQ5MzQgMjEuODc0OCA2LjU0NDM0IDIwLjkxNzMgNy44MTcwOCAyMC4yNTYyQzkuMDg5ODIgMTkuNTk1MiAxMC41MDI5IDE5LjI1MDEgMTEuOTM3MSAxOS4yNUMxMy4zNzEzIDE5LjI0OTkgMTQuNzg0NCAxOS41OTUgMTYuMDU3MiAyMC4yNTU5QzE3LjMzIDIwLjkxNjkgMTguNDI1MSAyMS44NzQ0IDE5LjI1IDIzLjA0NzUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMC4yMTY4IDE5LjI1QzIxLjY1MTEgMTkuMjQ5IDIzLjA2NDUgMTkuNTkzNiAyNC4zMzc0IDIwLjI1NDZDMjUuNjEwMyAyMC45MTU2IDI2LjcwNTIgMjEuODczNyAyNy41MjkzIDIzLjA0NzUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 1976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"menuContainer",staticClass:"menu-container",class:{'menu-container_hidden': !_vm.isVisible, 'menu-container_with-system': _vm.hasSystem},style:(_vm.containerStyle)},[_c('sidebar-menu',{attrs:{"menu":_vm.menu,"collapsed":_vm.isCollapsed,"width":_vm.expandedWidth,"width-collapsed":_vm.collapsedWidth,"hide-toggle":_vm.$store.getters.isMobile,"relative":""},on:{"toggle-collapse":_vm.onToggleCollapse}},[_c('span',{staticClass:"vsm-chevron",attrs:{"slot":"dropdown-icon"},slot:"dropdown-icon"}),_vm._v(" "),_c('span',{staticClass:"vsm-chevron vsm-chevron_toggle",attrs:{"slot":"toggle-icon"},slot:"toggle-icon"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__(1814);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f645d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__(1980);
function injectStyle (ssrContext) {
  __webpack_require__(1978)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29f645d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f645d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1978:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1979);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("09d834d3", content, true, {});

/***/ }),

/***/ 1979:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".user-menu[data-v-29f645d2]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:stretch;align-self:stretch}.user-menu__icon[data-v-29f645d2]{width:16px;height:16px;-ms-flex-negative:0;flex-shrink:0;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.user-menu__trigger[data-v-29f645d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;max-width:280px;padding:4px 10px 4px 4px;border:none;border-radius:999px;background:transparent;color:var(--header-fg);text-align:left;cursor:pointer;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.user-menu__trigger[data-v-29f645d2]:hover,.user-menu_open .user-menu__trigger[data-v-29f645d2]{background-color:var(--header-hover)}.user-menu__avatar[data-v-29f645d2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0;width:34px;height:34px;border-radius:50%;overflow:hidden;background-color:hsla(0,0%,100%,.18);-webkit-box-shadow:0 0 0 2px hsla(0,0%,100%,.28);box-shadow:0 0 0 2px hsla(0,0%,100%,.28);color:#fff;font-size:13px;font-weight:600;letter-spacing:.02em}.user-menu__avatar img[data-v-29f645d2]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.user-menu__identity[data-v-29f645d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0;line-height:1.25}.user-menu__name[data-v-29f645d2],.user-menu__role[data-v-29f645d2]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.user-menu__name[data-v-29f645d2]{font-size:13.5px;font-weight:600;color:var(--header-fg)}.user-menu__role[data-v-29f645d2]{font-size:11.5px;color:var(--header-muted)}.user-menu__chevron[data-v-29f645d2]{color:var(--header-muted);-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease}.user-menu_open .user-menu__chevron[data-v-29f645d2]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.user-menu__panel[data-v-29f645d2]{position:absolute;top:calc(100% + 6px);right:0;z-index:30;width:296px;padding:6px;border:1px solid var(--popover-border);border-radius:14px;background-color:var(--popover-bg);-webkit-box-shadow:var(--popover-shadow);box-shadow:var(--popover-shadow);color:var(--popover-fg);-webkit-transform-origin:top right;transform-origin:top right}.user-menu__panel[data-v-29f645d2]:before{content:\"\";position:absolute;top:-8px;left:0;right:0;height:8px}.user-menu__header[data-v-29f645d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:10px 10px 12px}.user-menu__avatar_large[data-v-29f645d2]{width:42px;height:42px;background-image:linear-gradient(135deg,#0e4759,#2c8ca3);-webkit-box-shadow:none;box-shadow:none;font-size:15px}.user-menu__header-text[data-v-29f645d2]{min-width:0}.user-menu__header-meta[data-v-29f645d2],.user-menu__header-name[data-v-29f645d2]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.user-menu__header-name[data-v-29f645d2]{font-size:14px;font-weight:600;color:var(--popover-fg)}.user-menu__header-meta[data-v-29f645d2]{font-size:12px;color:var(--popover-muted)}.user-menu__separator[data-v-29f645d2]{height:1px;margin:6px -6px;background-color:var(--popover-border)}.user-menu__item[data-v-29f645d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;width:100%;padding:8px 10px;border:none;border-radius:8px;background:transparent;color:var(--popover-fg);font-size:14px;text-align:left;cursor:pointer;-webkit-transition:background-color .12s ease,color .12s ease;transition:background-color .12s ease,color .12s ease}.user-menu__item .user-menu__icon[data-v-29f645d2]{color:var(--popover-muted);-webkit-transition:color .12s ease;transition:color .12s ease}.user-menu__item[data-v-29f645d2]:focus-visible,.user-menu__item[data-v-29f645d2]:hover{background-color:var(--popover-hover)}.user-menu__item_danger:hover .user-menu__icon[data-v-29f645d2],.user-menu__item_danger[data-v-29f645d2]:focus-visible,.user-menu__item_danger[data-v-29f645d2]:hover{background-color:var(--danger-hover-bg);color:var(--danger)}.user-menu__section[data-v-29f645d2]{padding:6px 4px 8px}.user-menu__label[data-v-29f645d2]{padding:0 6px 6px;font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--popover-muted)}.user-menu__segments[data-v-29f645d2]{display:grid;gap:4px;padding:4px;border-radius:10px;background-color:var(--segment-bg)}.user-menu__segments_theme[data-v-29f645d2]{grid-template-columns:repeat(3,1fr)}.user-menu__segment[data-v-29f645d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:7px;min-width:0;padding:7px 6px;border:1px solid transparent;border-radius:7px;background:transparent;color:var(--popover-muted);font-size:12.5px;font-weight:500;white-space:nowrap;cursor:pointer;-webkit-transition:background-color .12s ease,color .12s ease;transition:background-color .12s ease,color .12s ease}.user-menu__segments_theme .user-menu__segment[data-v-29f645d2]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:4px;padding:8px 4px}.user-menu__segment[data-v-29f645d2]:hover{color:var(--popover-fg)}.user-menu__segment_active[data-v-29f645d2],.user-menu__segment_active[data-v-29f645d2]:hover{border-color:var(--popover-border);background-color:var(--segment-active-bg);color:var(--segment-active-fg);font-weight:600}.user-menu__segment_active .user-menu__icon[data-v-29f645d2]{color:var(--accent)}.user-menu__select[data-v-29f645d2]{position:relative}.user-menu__select-option[data-v-29f645d2],.user-menu__select-trigger[data-v-29f645d2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;width:100%;padding:8px 10px;font-size:13px;color:var(--popover-fg);cursor:pointer}.user-menu__select-trigger[data-v-29f645d2]{border:1px solid var(--popover-border);border-radius:10px;background-color:var(--segment-bg);text-align:left;font-weight:500;-webkit-transition:border-color .12s ease,background-color .12s ease;transition:border-color .12s ease,background-color .12s ease}.user-menu__select-trigger[data-v-29f645d2]:hover,.user-menu__select_open .user-menu__select-trigger[data-v-29f645d2]{background-color:var(--popover-hover)}.user-menu__select-trigger[data-v-29f645d2]:focus-visible{outline:2px solid var(--accent);outline-offset:1px}.user-menu__select-label[data-v-29f645d2]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.user-menu__select-chevron[data-v-29f645d2]{color:var(--popover-muted);-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease}.user-menu__select_open .user-menu__select-chevron[data-v-29f645d2]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.user-menu__select-list[data-v-29f645d2]{position:absolute;top:calc(100% + 4px);left:0;right:0;z-index:1;margin:0;padding:4px;list-style:none;border:1px solid var(--popover-border);border-radius:10px;background-color:var(--popover-bg);-webkit-box-shadow:var(--popover-shadow);box-shadow:var(--popover-shadow)}.user-menu__select-option[data-v-29f645d2]{border-radius:7px}.user-menu__select-option_focused[data-v-29f645d2]{background-color:var(--popover-hover)}.user-menu__select-option_active[data-v-29f645d2]{font-weight:600}.user-menu__select-check[data-v-29f645d2]{color:var(--accent)}.user-menu__flag[data-v-29f645d2]{width:20px;height:14px;-ms-flex-negative:0;flex-shrink:0;border-radius:2px;-webkit-box-shadow:0 0 0 1px rgba(0,0,0,.12);box-shadow:0 0 0 1px rgba(0,0,0,.12)}.user-menu-enter-active[data-v-29f645d2],.user-menu-leave-active[data-v-29f645d2]{-webkit-transition:opacity .14s ease,-webkit-transform .14s ease;transition:opacity .14s ease,-webkit-transform .14s ease;transition:opacity .14s ease,transform .14s ease;transition:opacity .14s ease,transform .14s ease,-webkit-transform .14s ease}.user-menu-enter[data-v-29f645d2],.user-menu-leave-to[data-v-29f645d2]{opacity:0;-webkit-transform:translateY(-4px) scale(.98);transform:translateY(-4px) scale(.98)}@media only screen and (max-width:700px){.user-menu__chevron[data-v-29f645d2],.user-menu__identity[data-v-29f645d2]{display:none}.user-menu__trigger[data-v-29f645d2]{padding:4px}.user-menu__panel[data-v-29f645d2]{width:min(296px,calc(100vw - 16px))}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Main/UserMenu.vue"],"names":[],"mappings":"AACA,4BACI,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AACzB,kBAAoB,CAC3B,AACD,kCACI,WAAY,AACZ,YAAa,AACb,oBAAqB,AACjB,cAAe,AACnB,UAAW,AACX,oBAAqB,AACrB,eAAgB,AAChB,qBAAsB,AACtB,qBAAuB,CAC1B,AAGD,qCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,gBAAiB,AACjB,yBAA0B,AAC1B,YAAa,AACb,oBAAqB,AACrB,uBAAwB,AACxB,uBAAwB,AACxB,gBAAiB,AACjB,eAAgB,AAChB,8CAAgD,AAChD,qCAAwC,CAC3C,AACD,gGAEI,oCAAsC,CACzC,AACD,oCACI,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,oBAAqB,AACjB,cAAe,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,gBAAiB,AACjB,qCAA4C,AAC5C,iDAAwD,AAChD,yCAAgD,AACxD,WAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,oBAAuB,CAC1B,AACD,wCACI,WAAY,AACZ,YAAa,AACb,oBAAqB,AAClB,gBAAkB,CACxB,AACD,sCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,YAAa,AACb,gBAAkB,CACrB,AACD,oEAEI,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,kCACI,iBAAkB,AAClB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,kCACI,iBAAkB,AAClB,yBAA2B,CAC9B,AACD,qCACI,0BAA2B,AAC3B,8CAAgD,AAChD,sCAAwC,AACxC,8BAAgC,AAChC,wDAA6D,CAChE,AACD,qDACI,iCAAkC,AAC1B,wBAA0B,CACrC,AAGD,mCACI,kBAAmB,AACnB,qBAAsB,AACtB,QAAS,AACT,WAAY,AACZ,YAAa,AACb,YAAa,AACb,uCAAwC,AACxC,mBAAoB,AACpB,mCAAoC,AACpC,yCAA0C,AAClC,iCAAkC,AAC1C,wBAAyB,AACzB,mCAAoC,AAC5B,0BAA4B,CACvC,AAID,0CACI,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,OAAQ,AACR,QAAS,AACT,UAAY,CACf,AACD,oCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,sBAAwB,CAC3B,AACD,0CACI,WAAY,AACZ,YAAa,AACb,yDAA4D,AAC5D,wBAAyB,AACjB,gBAAiB,AACzB,cAAgB,CACnB,AACD,yCACI,WAAa,CAChB,AACD,kFAEI,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,yCACI,eAAgB,AAChB,gBAAiB,AACjB,uBAAyB,CAC5B,AACD,yCACI,eAAgB,AAChB,0BAA4B,CAC/B,AACD,uCACI,WAAY,AACZ,gBAAiB,AACjB,sCAAwC,CAC3C,AACD,kCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,WAAY,AACZ,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,uBAAwB,AACxB,wBAAyB,AACzB,eAAgB,AAChB,gBAAiB,AACjB,eAAgB,AAChB,8DAAkE,AAClE,qDAA0D,CAC7D,AACD,mDACI,2BAA4B,AAC5B,mCAAqC,AACrC,0BAA6B,CAChC,AACD,wFAEI,qCAAuC,CAC1C,AACD,sKAGI,wCAAyC,AACzC,mBAAqB,CACxB,AACD,qCACI,mBAAqB,CACxB,AACD,mCACI,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,qBAAuB,AACvB,yBAA0B,AAC1B,0BAA4B,CAC/B,AAID,sCACI,aAAc,AACd,QAAS,AACT,YAAa,AACb,mBAAoB,AACpB,kCAAoC,CACvC,AACD,4CACI,mCAAsC,CACzC,AACD,qCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,QAAS,AACT,YAAa,AACb,gBAAiB,AACjB,6BAA8B,AAC9B,kBAAmB,AACnB,uBAAwB,AACxB,2BAA4B,AAC5B,iBAAkB,AAClB,gBAAiB,AACjB,mBAAoB,AACpB,eAAgB,AAChB,8DAAkE,AAClE,qDAA0D,CAC7D,AACD,gEACI,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,QAAS,AACT,eAAiB,CACpB,AACD,2CACI,uBAAyB,CAC5B,AACD,8FAEI,mCAAoC,AACpC,0CAA2C,AAC3C,+BAAgC,AAChC,eAAiB,CACpB,AACD,6DACI,mBAAqB,CACxB,AACD,oCACI,iBAAmB,CACtB,AACD,uFAEI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,SAAU,AACV,WAAY,AACZ,iBAAkB,AAClB,eAAgB,AAChB,wBAAyB,AACzB,cAAgB,CACnB,AACD,4CACI,uCAAwC,AACxC,mBAAoB,AACpB,mCAAoC,AACpC,gBAAiB,AACjB,gBAAiB,AACjB,qEAAyE,AACzE,4DAAiE,CACpE,AACD,sHAEI,qCAAuC,CAC1C,AACD,0DACI,gCAAiC,AACjC,kBAAoB,CACvB,AACD,0CACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,YAAa,AACb,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CAC3B,AACD,4CACI,2BAA4B,AAC5B,8CAAgD,AAChD,sCAAwC,AACxC,8BAAgC,AAChC,wDAA6D,CAChE,AACD,oEACI,iCAAkC,AAC1B,wBAA0B,CACrC,AACD,yCACI,kBAAmB,AACnB,qBAAsB,AACtB,OAAQ,AACR,QAAS,AACT,UAAW,AACX,SAAU,AACV,YAAa,AACb,gBAAiB,AACjB,uCAAwC,AACxC,mBAAoB,AACpB,mCAAoC,AACpC,yCAA0C,AAClC,gCAAkC,CAC7C,AACD,2CACI,iBAAmB,CACtB,AACD,mDACI,qCAAuC,CAC1C,AACD,kDACI,eAAiB,CACpB,AACD,0CACI,mBAAqB,CACxB,AACD,kCACI,WAAY,AACZ,YAAa,AACb,oBAAqB,AACjB,cAAe,AACnB,kBAAmB,AACnB,6CAAkD,AAC1C,oCAA0C,CACrD,AACD,kFAEI,iEAAqE,AACrE,yDAA6D,AAC7D,iDAAqD,AACrD,4EAAmF,CACtF,AACD,uEAEI,UAAW,AACX,8CAAgD,AACxC,qCAAwC,CACnD,AACD,yCACA,2EAEQ,YAAc,CACrB,AACD,qCACQ,WAAa,CACpB,AACD,mCACQ,mCAAsC,CAC7C,CACA","file":"UserMenu.vue","sourcesContent":["\n.user-menu[data-v-29f645d2] {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-item-align: stretch;\n        align-self: stretch;\n}\n.user-menu__icon[data-v-29f645d2] {\n    width: 16px;\n    height: 16px;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n}\n\n/* --- Przycisk na pasku --- */\n.user-menu__trigger[data-v-29f645d2] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    max-width: 280px;\n    padding: 4px 10px 4px 4px;\n    border: none;\n    border-radius: 999px;\n    background: transparent;\n    color: var(--header-fg);\n    text-align: left;\n    cursor: pointer;\n    -webkit-transition: background-color 0.15s ease;\n    transition: background-color 0.15s ease;\n}\n.user-menu__trigger[data-v-29f645d2]:hover,\n.user-menu_open .user-menu__trigger[data-v-29f645d2] {\n    background-color: var(--header-hover);\n}\n.user-menu__avatar[data-v-29f645d2] {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    overflow: hidden;\n    background-color: rgba(255, 255, 255, 0.18);\n    -webkit-box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.28);\n            box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.28);\n    color: #ffffff;\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n}\n.user-menu__avatar img[data-v-29f645d2] {\n    width: 100%;\n    height: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n}\n.user-menu__identity[data-v-29f645d2] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    min-width: 0;\n    line-height: 1.25;\n}\n.user-menu__name[data-v-29f645d2],\n.user-menu__role[data-v-29f645d2] {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.user-menu__name[data-v-29f645d2] {\n    font-size: 13.5px;\n    font-weight: 600;\n    color: var(--header-fg);\n}\n.user-menu__role[data-v-29f645d2] {\n    font-size: 11.5px;\n    color: var(--header-muted);\n}\n.user-menu__chevron[data-v-29f645d2] {\n    color: var(--header-muted);\n    -webkit-transition: -webkit-transform 0.2s ease;\n    transition: -webkit-transform 0.2s ease;\n    transition: transform 0.2s ease;\n    transition: transform 0.2s ease, -webkit-transform 0.2s ease;\n}\n.user-menu_open .user-menu__chevron[data-v-29f645d2] {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg);\n}\n\n/* --- Panel --- */\n.user-menu__panel[data-v-29f645d2] {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    z-index: 30;\n    width: 296px;\n    padding: 6px;\n    border: 1px solid var(--popover-border);\n    border-radius: 14px;\n    background-color: var(--popover-bg);\n    -webkit-box-shadow: var(--popover-shadow);\n            box-shadow: var(--popover-shadow);\n    color: var(--popover-fg);\n    -webkit-transform-origin: top right;\n            transform-origin: top right;\n}\n\n/* Mostek nad panelem: kursor przejeżdżający przez odstęp od paska\n   nie opuszcza menu, więc hover nie gaśnie po drodze. */\n.user-menu__panel[data-v-29f645d2]::before {\n    content: \"\";\n    position: absolute;\n    top: -8px;\n    left: 0;\n    right: 0;\n    height: 8px;\n}\n.user-menu__header[data-v-29f645d2] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 12px;\n    padding: 10px 10px 12px;\n}\n.user-menu__avatar_large[data-v-29f645d2] {\n    width: 42px;\n    height: 42px;\n    background-image: linear-gradient(135deg, #0e4759, #2c8ca3);\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    font-size: 15px;\n}\n.user-menu__header-text[data-v-29f645d2] {\n    min-width: 0;\n}\n.user-menu__header-name[data-v-29f645d2],\n.user-menu__header-meta[data-v-29f645d2] {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.user-menu__header-name[data-v-29f645d2] {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--popover-fg);\n}\n.user-menu__header-meta[data-v-29f645d2] {\n    font-size: 12px;\n    color: var(--popover-muted);\n}\n.user-menu__separator[data-v-29f645d2] {\n    height: 1px;\n    margin: 6px -6px;\n    background-color: var(--popover-border);\n}\n.user-menu__item[data-v-29f645d2] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 8px 10px;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    color: var(--popover-fg);\n    font-size: 14px;\n    text-align: left;\n    cursor: pointer;\n    -webkit-transition: background-color 0.12s ease, color 0.12s ease;\n    transition: background-color 0.12s ease, color 0.12s ease;\n}\n.user-menu__item .user-menu__icon[data-v-29f645d2] {\n    color: var(--popover-muted);\n    -webkit-transition: color 0.12s ease;\n    transition: color 0.12s ease;\n}\n.user-menu__item[data-v-29f645d2]:hover,\n.user-menu__item[data-v-29f645d2]:focus-visible {\n    background-color: var(--popover-hover);\n}\n.user-menu__item_danger[data-v-29f645d2]:hover,\n.user-menu__item_danger[data-v-29f645d2]:focus-visible,\n.user-menu__item_danger:hover .user-menu__icon[data-v-29f645d2] {\n    background-color: var(--danger-hover-bg);\n    color: var(--danger);\n}\n.user-menu__section[data-v-29f645d2] {\n    padding: 6px 4px 8px;\n}\n.user-menu__label[data-v-29f645d2] {\n    padding: 0 6px 6px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--popover-muted);\n}\n\n/* Przełączniki segmentowe i lista języków zamiast natywnego <select>, który otwiera\n   listę poza panelem, przez co menu z hoverem zamykałoby się w trakcie wyboru. */\n.user-menu__segments[data-v-29f645d2] {\n    display: grid;\n    gap: 4px;\n    padding: 4px;\n    border-radius: 10px;\n    background-color: var(--segment-bg);\n}\n.user-menu__segments_theme[data-v-29f645d2] {\n    grid-template-columns: repeat(3, 1fr);\n}\n.user-menu__segment[data-v-29f645d2] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    gap: 7px;\n    min-width: 0;\n    padding: 7px 6px;\n    border: 1px solid transparent;\n    border-radius: 7px;\n    background: transparent;\n    color: var(--popover-muted);\n    font-size: 12.5px;\n    font-weight: 500;\n    white-space: nowrap;\n    cursor: pointer;\n    -webkit-transition: background-color 0.12s ease, color 0.12s ease;\n    transition: background-color 0.12s ease, color 0.12s ease;\n}\n.user-menu__segments_theme .user-menu__segment[data-v-29f645d2] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    gap: 4px;\n    padding: 8px 4px;\n}\n.user-menu__segment[data-v-29f645d2]:hover {\n    color: var(--popover-fg);\n}\n.user-menu__segment_active[data-v-29f645d2],\n.user-menu__segment_active[data-v-29f645d2]:hover {\n    border-color: var(--popover-border);\n    background-color: var(--segment-active-bg);\n    color: var(--segment-active-fg);\n    font-weight: 600;\n}\n.user-menu__segment_active .user-menu__icon[data-v-29f645d2] {\n    color: var(--accent);\n}\n.user-menu__select[data-v-29f645d2] {\n    position: relative;\n}\n.user-menu__select-trigger[data-v-29f645d2],\n.user-menu__select-option[data-v-29f645d2] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 8px 10px;\n    font-size: 13px;\n    color: var(--popover-fg);\n    cursor: pointer;\n}\n.user-menu__select-trigger[data-v-29f645d2] {\n    border: 1px solid var(--popover-border);\n    border-radius: 10px;\n    background-color: var(--segment-bg);\n    text-align: left;\n    font-weight: 500;\n    -webkit-transition: border-color 0.12s ease, background-color 0.12s ease;\n    transition: border-color 0.12s ease, background-color 0.12s ease;\n}\n.user-menu__select-trigger[data-v-29f645d2]:hover,\n.user-menu__select_open .user-menu__select-trigger[data-v-29f645d2] {\n    background-color: var(--popover-hover);\n}\n.user-menu__select-trigger[data-v-29f645d2]:focus-visible {\n    outline: 2px solid var(--accent);\n    outline-offset: 1px;\n}\n.user-menu__select-label[data-v-29f645d2] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.user-menu__select-chevron[data-v-29f645d2] {\n    color: var(--popover-muted);\n    -webkit-transition: -webkit-transform 0.2s ease;\n    transition: -webkit-transform 0.2s ease;\n    transition: transform 0.2s ease;\n    transition: transform 0.2s ease, -webkit-transform 0.2s ease;\n}\n.user-menu__select_open .user-menu__select-chevron[data-v-29f645d2] {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg);\n}\n.user-menu__select-list[data-v-29f645d2] {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    z-index: 1;\n    margin: 0;\n    padding: 4px;\n    list-style: none;\n    border: 1px solid var(--popover-border);\n    border-radius: 10px;\n    background-color: var(--popover-bg);\n    -webkit-box-shadow: var(--popover-shadow);\n            box-shadow: var(--popover-shadow);\n}\n.user-menu__select-option[data-v-29f645d2] {\n    border-radius: 7px;\n}\n.user-menu__select-option_focused[data-v-29f645d2] {\n    background-color: var(--popover-hover);\n}\n.user-menu__select-option_active[data-v-29f645d2] {\n    font-weight: 600;\n}\n.user-menu__select-check[data-v-29f645d2] {\n    color: var(--accent);\n}\n.user-menu__flag[data-v-29f645d2] {\n    width: 20px;\n    height: 14px;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    border-radius: 2px;\n    -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);\n            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);\n}\n.user-menu-enter-active[data-v-29f645d2],\n.user-menu-leave-active[data-v-29f645d2] {\n    -webkit-transition: opacity 0.14s ease, -webkit-transform 0.14s ease;\n    transition: opacity 0.14s ease, -webkit-transform 0.14s ease;\n    transition: opacity 0.14s ease, transform 0.14s ease;\n    transition: opacity 0.14s ease, transform 0.14s ease, -webkit-transform 0.14s ease;\n}\n.user-menu-enter[data-v-29f645d2],\n.user-menu-leave-to[data-v-29f645d2] {\n    opacity: 0;\n    -webkit-transform: translateY(-4px) scale(0.98);\n            transform: translateY(-4px) scale(0.98);\n}\n@media only screen and (max-width: 700px) {\n.user-menu__identity[data-v-29f645d2],\n    .user-menu__chevron[data-v-29f645d2] {\n        display: none;\n}\n.user-menu__trigger[data-v-29f645d2] {\n        padding: 4px;\n}\n.user-menu__panel[data-v-29f645d2] {\n        width: min(296px, calc(100vw - 16px));\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],staticClass:"user-menu",class:{ 'user-menu_open': _vm.isOpen },on:{"pointerenter":_vm.onPointerEnter,"pointerleave":_vm.onPointerLeave,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close.apply(null, arguments)}}},[_c('button',{staticClass:"user-menu__trigger",attrs:{"type":"button","aria-haspopup":"menu","aria-expanded":String(_vm.isOpen)},on:{"pointerdown":function($event){_vm.lastPointerType = $event.pointerType},"click":_vm.onTriggerClick}},[_c('span',{staticClass:"user-menu__avatar"},[(_vm.showPhoto)?_c('img',{attrs:{"src":_vm.avatarUrl,"alt":""},on:{"error":function($event){_vm.avatarFailed = true}}}):[_vm._v(_vm._s(_vm.initials))]],2),_vm._v(" "),_c('span',{staticClass:"user-menu__identity"},[_c('span',{staticClass:"user-menu__name"},[_vm._v(_vm._s(_vm.displayName))]),_vm._v(" "),_c('span',{staticClass:"user-menu__role"},[_vm._v(_vm._s(_vm.roleLabel))])]),_vm._v(" "),_c('svg',{staticClass:"user-menu__icon user-menu__chevron",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icons.chevronDown)}})]),_vm._v(" "),_c('transition',{attrs:{"name":"user-menu"}},[(_vm.isOpen)?_c('div',{staticClass:"user-menu__panel",attrs:{"role":"menu"}},[_c('div',{staticClass:"user-menu__header"},[_c('span',{staticClass:"user-menu__avatar user-menu__avatar_large"},[(_vm.showPhoto)?_c('img',{attrs:{"src":_vm.avatarUrl,"alt":""},on:{"error":function($event){_vm.avatarFailed = true}}}):[_vm._v(_vm._s(_vm.initials))]],2),_vm._v(" "),_c('div',{staticClass:"user-menu__header-text"},[_c('div',{staticClass:"user-menu__header-name"},[_vm._v(_vm._s(_vm.displayName))]),_vm._v(" "),_c('div',{staticClass:"user-menu__header-meta"},[_vm._v(_vm._s(_vm.user.email || _vm.roleLabel))])])]),_vm._v(" "),_c('div',{staticClass:"user-menu__separator"}),_vm._v(" "),_c('button',{staticClass:"user-menu__item",attrs:{"type":"button","role":"menuitem"},on:{"click":_vm.editProfile}},[_c('svg',{staticClass:"user-menu__icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icons.user)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Profile')))])]),_vm._v(" "),_c('div',{staticClass:"user-menu__separator"}),_vm._v(" "),_c('div',{staticClass:"user-menu__section"},[_c('div',{staticClass:"user-menu__label"},[_vm._v(_vm._s(_vm.$t('Theme')))]),_vm._v(" "),_c('div',{staticClass:"user-menu__segments user-menu__segments_theme",attrs:{"role":"group","aria-label":_vm.$t('Theme')}},_vm._l((_vm.themeOptions),function(option){return _c('button',{key:option.value,staticClass:"user-menu__segment",class:{ 'user-menu__segment_active': _vm.theme === option.value },attrs:{"type":"button","aria-pressed":String(_vm.theme === option.value)},on:{"click":function($event){return _vm.setTheme(option.value)}}},[_c('svg',{staticClass:"user-menu__icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icons[option.icon])}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(option.labelKey)))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"user-menu__section"},[_c('div',{staticClass:"user-menu__label"},[_vm._v(_vm._s(_vm.$t('Language')))]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeLanguage),expression:"closeLanguage"}],staticClass:"user-menu__select",class:{ 'user-menu__select_open': _vm.isLanguageOpen },on:{"keydown":_vm.onLanguageKeydown}},[_c('button',{ref:"languageTrigger",staticClass:"user-menu__select-trigger",attrs:{"type":"button","aria-haspopup":"listbox","aria-expanded":String(_vm.isLanguageOpen),"aria-label":_vm.$t('Language')},on:{"click":_vm.toggleLanguage}},[_c('svg',{staticClass:"user-menu__flag",attrs:{"viewBox":"0 0 60 40","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.currentLanguage.flag)}}),_vm._v(" "),_c('span',{staticClass:"user-menu__select-label"},[_vm._v(_vm._s(_vm.currentLanguage.label))]),_vm._v(" "),_c('svg',{staticClass:"user-menu__icon user-menu__select-chevron",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icons.chevronDown)}})]),_vm._v(" "),(_vm.isLanguageOpen)?_c('ul',{staticClass:"user-menu__select-list",attrs:{"role":"listbox","aria-label":_vm.$t('Language')}},_vm._l((_vm.languageOptions),function(option,index){return _c('li',{key:option.value,staticClass:"user-menu__select-option",class:{
                                'user-menu__select-option_active': _vm.language === option.value,
                                'user-menu__select-option_focused': _vm.focusedLanguage === index
                            },attrs:{"role":"option","aria-selected":String(_vm.language === option.value)},on:{"mouseenter":function($event){_vm.focusedLanguage = index},"click":function($event){return _vm.setLanguage(option.value)}}},[_c('svg',{staticClass:"user-menu__flag",attrs:{"viewBox":"0 0 60 40","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(option.flag)}}),_vm._v(" "),_c('span',{staticClass:"user-menu__select-label"},[_vm._v(_vm._s(option.label))]),_vm._v(" "),(_vm.language === option.value)?_c('svg',{staticClass:"user-menu__icon user-menu__select-check",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icons.check)}}):_vm._e()])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"user-menu__separator"}),_vm._v(" "),_c('button',{staticClass:"user-menu__item user-menu__item_danger",attrs:{"type":"button","role":"menuitem"},on:{"click":_vm.logout}},[_c('svg',{staticClass:"user-menu__icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.icons.logOut)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('Logout')))])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1981:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-shell",attrs:{"id":"app"}},[_c('modal',{attrs:{"showDialog":_vm.activeModal == 'EDITPROFILE',"title":_vm.$t('EditProfile')},on:{"close":function () { return _vm.activeModal = 'NONE'; }}},[_c('edit-profile',{staticStyle:{"width":"25vw","overflow-y":"scroll"},on:{"cancel":function($event){_vm.activeModal = 'NONE'},"save":function($event){_vm.activeModal = 'NONE'}}})],1),_vm._v(" "),_c('header',{staticClass:"top-logo-bar app-header"},[_c('div',{staticClass:"app-header__start"},[_c('button',{staticClass:"app-header__icon-button",attrs:{"type":"button","aria-label":"Menu","aria-expanded":String(_vm.menuVisible)},on:{"click":function($event){_vm.menuVisible = !_vm.menuVisible}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('rect',{attrs:{"width":"18","height":"18","x":"3","y":"3","rx":"2"}}),_c('path',{attrs:{"d":"M9 3v18"}})])]),_vm._v(" "),_c('span',{staticClass:"app-header__separator"}),_vm._v(" "),_c('router-link',{staticClass:"app-header__logo",attrs:{"to":{name: 'systems'}}},[_c('img',{staticClass:"app-logo",attrs:{"src":__webpack_require__(1620),"alt":"CRFI Monitoring"}})]),_vm._v(" "),(_vm.isSystem && !_vm.$store.getters.isMobile && _vm.$route.params.systemName)?[_c('span',{staticClass:"app-header__separator"}),_vm._v(" "),_c('span',{staticClass:"app-header__context"},[_vm._v(_vm._s(_vm.$route.params.systemName))])]:_vm._e()],2),_vm._v(" "),_c('user-menu',{on:{"edit-profile":_vm.editProfile}})],1),_vm._v(" "),_c('div',{staticClass:"horizontal grow",staticStyle:{"max-width":"100vw","overflow":"hidden"}},[_c('div',[_c('NavigationMenu',{attrs:{"absolute":_vm.menuAbsolute,"isVisible":_vm.menuVisible}})],1),_vm._v(" "),_c('div',{staticClass:"main-router-view",attrs:{"id":"main-router-view"}},[(_vm.$store.getters.isLoading)?_c('div',{staticClass:"mySpinner"},[_c('Spinner',{staticStyle:{"width":"100%","position":"fixed","top":"50vh"}})],1):_vm._e(),_vm._v(" "),_c('router-view',{staticClass:"scrollbar style-2",staticStyle:{"height":"calc(100vh - 50px)"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.42418b167a52515891ef.js